<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ch-title"><a id="page_5">Oedipus Rex</a></h2><a id="page_5">
<p class="noindent"><em class="italic">Suppliants of all ages are seated round the altar at the palace doors, at their head a PRIEST OF ZEUS. To them enter OEDIPUS.</em></p>
<p class="poem1">OEDIPUS: My children, latest born to Cadmus old,</p>
<p class="poem">Why sit ye here as suppliants, in your hands</p>
<p class="poem">Branches of olive filleted with wool?</p>
<p class="poem">What means this reek of incense everywhere,</p>
<p class="poem">And everywhere laments and litanies?</p>
<p class="poem">Children, it were not meet that I should learn</p>
<p class="poem">From others, and am hither come, myself,</p>
<p class="poem">I Oedipus, your world-renowned king.</p>
<p class="poem">Ho! aged sire, whose venerable locks</p>
<p class="poem">Proclaim thee spokesman of this company,</p>
<p class="poem">Explain your mood and purport. Is it dread</p>
<p class="poem">Of ill that moves you or a boon ye crave?</p>
<p class="poem">My zeal in your behalf ye cannot doubt;</p>
<p class="poem">Ruthless indeed were I and obdurate</p>
<p class="poem">If such petitioners as you I spurned.</p>
<p class="poem1">PRIEST: Yea, Oedipus, my sovereign lord and king,</p>
<p class="poem">Thou seest how both extremes of age besiege</p>
<p class="poem">Thy palace altars—fledglings hardly winged,</p>
<p class="poem">and greybeards bowed with years; priests, as am I</p>
<p class="poem">of Zeus, and these the flower of our youth.</p>
<p class="poem">Meanwhile, the common folk, with wreathed boughs</p>
</a><p class="poem"><a id="page_5"></a><a id="page_6">Crowd our two market-places, or before</a></p><a id="page_6">
<p class="poem">Both shrines of Pallas congregate, or where</p>
<p class="poem">Ismenus gives his oracles by fire.</p>
<p class="poem">For, as thou seest thyself, our ship of State,</p>
<p class="poem">Sore buffeted, can no more lift her head,</p>
<p class="poem">Foundered beneath a weltering surge of blood.</p>
<p class="poem">A blight is on our harvest in the ear,</p>
<p class="poem">A blight upon the grazing flocks and herds,</p>
<p class="poem">A blight on wives in travail; and withal</p>
<p class="poem">Armed with his blazing torch the God of Plague</p>
<p class="poem">Hath swooped upon our city emptying</p>
<p class="poem">The house of Cadmus, and the murky realm</p>
<p class="poem">Of Pluto is full fed with groans and tears.</p>
<p class="poemi">Therefore, O King, here at thy hearth we sit,</p>
<p class="poem">I and these children; not as deeming thee</p>
<p class="poem">A new divinity, but the first of men;</p>
<p class="poem">First in the common accidents of life,</p>
<p class="poem">And first in visitations of the Gods.</p>
<p class="poem">Art thou not he who coming to the town</p>
<p class="poem">of Cadmus freed us from the tax we paid</p>
<p class="poem">To the fell songstress? Nor hadst thou received</p>
<p class="poem">Prompting from us or been by others schooled;</p>
<p class="poem">No, by a god inspired (so all men deem,</p>
<p class="poem">And testify) didst thou renew our life.</p>
<p class="poem">And now, O Oedipus, our peerless king,</p>
<p class="poem">All we thy votaries beseech thee, find</p>
<p class="poem">Some succor, whether by a voice from heaven</p>
<p class="poem">Whispered, or haply known by human wit.</p>
<p class="poem">Tried counselors, methinks, are aptest found <em class="italic"><span class="underline">1</span></em></p>
<p class="poem">To furnish for the future pregnant rede.</p>
<p class="poem">Upraise, O chief of men, upraise our State!</p>
<p class="poem">Look to thy laurels! for thy zeal of yore</p>
</a><p class="poem"><a id="page_6"></a><a id="page_7">Our country’s savior thou art justly hailed:</a></p><a id="page_7">
<p class="poem">O never may we thus record thy reign:—</p>
<p class="poem">“He raised us up only to cast us down.”</p>
<p class="poem">Uplift us, build our city on a rock.</p>
<p class="poem">Thy happy star ascendant brought us luck,</p>
<p class="poem">O let it not decline! If thou wouldst rule</p>
<p class="poem">This land, as now thou reignest, better sure</p>
<p class="poem">To rule a peopled than a desert realm.</p>
<p class="poem">Nor battlements nor galleys aught avail,</p>
<p class="poem">If men to man and guards to guard them tail.</p>
<p class="poem1">OEDIPUS: Ah! my poor children, known, ah, known too well,</p>
<p class="poem">The quest that brings you hither and your need.</p>
<p class="poem">Ye sicken all, well wot I, yet my pain,</p>
<p class="poem">How great soever yours, outtops it all.</p>
<p class="poem">Your sorrow touches each man severally,</p>
<p class="poem">Him and none other, but I grieve at once</p>
<p class="poem">Both for the general and myself and you.</p>
<p class="poem">Therefore ye rouse no sluggard from day-dreams.</p>
<p class="poem">Many, my children, are the tears I’ve wept,</p>
<p class="poem">And threaded many a maze of weary thought.</p>
<p class="poem">Thus pondering one clue of hope I caught,</p>
<p class="poem">And tracked it up; I have sent Menoeceus’ son,</p>
<p class="poem">Creon, my consort’s brother, to inquire</p>
<p class="poem">Of Pythian Phoebus at his Delphic shrine,</p>
<p class="poem">How I might save the State by act or word.</p>
<p class="poem">And now I reckon up the tale of days</p>
<p class="poem">Since he set forth, and marvel how he fares.</p>
<p class="poem">‘Tis strange, this endless tarrying, passing strange.</p>
<p class="poem">But when he comes, then I were base indeed,</p>
<p class="poem">If I perform not all the god declares.</p>
</a><p class="poem1"><a id="page_7"></a><a id="page_8">PRIEST: Thy words are well timed; even as thou speakest</a></p><a id="page_8">
<p class="poem">That shouting tells me Creon is at hand.</p>
<p class="poem1">OEDIPUS: O King Apollo! may his joyous looks</p>
<p class="poem">Be presage of the joyous news he brings!</p>
<p class="poem1">PRIEST: As I surmise, ‘tis welcome; else his head</p>
<p class="poem">Had scarce been crowned with berry-laden bays.</p>
<p class="poem1">OEDIPUS: We soon shall know; he’s now in earshot range.</p>
<p class="poem">[Enter CREON]</p>
<p class="poem">My royal cousin, say, Menoeceus’ child,</p>
<p class="poem">What message hast thou brought us from the god?</p>
<p class="poem1">CREON: Good news, for e’en intolerable ills,</p>
<p class="poem">Finding right issue, tend to naught but good.</p>
<p class="poem1">OEDIPUS: How runs the oracle? thus far thy words</p>
<p class="poem">Give me no ground for confidence or fear.</p>
<p class="poem1">CREON: If thou wouldst hear my message publicly,</p>
<p class="poem">I’ll tell thee straight, or with thee pass within.</p>
<p class="poem1">OEDIPUS: Speak before all; the burden that I bear</p>
<p class="poem">Is more for these my subjects than myself.</p>
<p class="poem1">CREON: Let me report then all the god declared.</p>
<p class="poem">King Phoebus bids us straitly extirpate</p>
<p class="poem">A fell pollution that infests the land,</p>
<p class="poem">And no more harbor an inveterate sore.</p>
<p class="poem1">OEDIPUS: What expiation means he? What’s amiss?</p>
</a><p class="poem1"><a id="page_8"></a><a id="page_9">CREON: Banishment, or the shedding blood for blood.</a></p><a id="page_9">
<p class="poem">This stain of blood makes shipwreck of our state.</p>
<p class="poem1">OEDIPUS: Whom can he mean, the miscreant thus denounced?</p>
<p class="poem1">CREON: Before thou didst assume the helm of State,</p>
<p class="poem">The sovereign of this land was Laius.</p>
<p class="poem1">OEDIPUS: I heard as much, but never saw the man.</p>
<p class="poem1">CREON: He fell; and now the god’s command is plain:</p>
<p class="poem">Punish his takers-off, whoe’er they be.</p>
<p class="poem1">OEDIPUS: Where are they? Where in the wide world to find</p>
<p class="poem">The far, faint traces of a bygone crime?</p>
<p class="poem1">CREON: In this land, said the god; “who seeks shall find;</p>
<p class="poem">Who sits with folded hands or sleeps is blind.”</p>
<p class="poem1">OEDIPUS: Was he within his palace, or afield,</p>
<p class="poem">Or traveling, when Laius met his fate?</p>
<p class="poem1">CREON: Abroad; he started, so he told us, bound</p>
<p class="poem">For Delphi, but he never thence returned.</p>
<p class="poem1">OEDIPUS: Came there no news, no fellow-traveler</p>
<p class="poem">To give some clue that might be followed up?</p>
<p class="poem1">CREON: But one escape, who flying for dear life,</p>
<p class="poem">Could tell of all he saw but one thing sure.</p>
<p class="poem1">OEDIPUS: And what was that? One clue might lead us far,</p>
</a><p class="poem"><a id="page_9"></a><a id="page_10">With but a spark of hope to guide our quest.</a></p><a id="page_10">
<p class="poem1">CREON: Robbers, he told us, not one bandit but</p>
<p class="poem">A troop of knaves, attacked and murdered him.</p>
<p class="poem1">OEDIPUS: Did any bandit dare so bold a stroke,</p>
<p class="poem">Unless indeed he were suborned from Thebes?</p>
<p class="poem1">CREON: So ‘twas surmised, but none was found to avenge</p>
<p class="poem">His murder mid the trouble that ensued.</p>
<p class="poem1">OEDIPUS: What trouble can have hindered a full quest,</p>
<p class="poem">When royalty had fallen thus miserably?</p>
<p class="poem1">CREON: The riddling Sphinx compelled us to let slide</p>
<p class="poem">The dim past and attend to instant needs.</p>
<p class="poem1">OEDIPUS: Well, I will start afresh and once again</p>
<p class="poem">Make dark things clear. Right worthy the concern</p>
<p class="poem">Of Phoebus, worthy thine too, for the dead;</p>
<p class="poem">I also, as is meet, will lend my aid</p>
<p class="poem">To avenge this wrong to Thebes and to the god.</p>
<p class="poem">Not for some far-off kinsman, but myself,</p>
<p class="poem">Shall I expel this poison in the blood;</p>
<p class="poem">For whoso slew that king might have a mind</p>
<p class="poem">To strike me too with his assassin hand.</p>
<p class="poem">Therefore in righting him I serve myself.</p>
<p class="poem">Up, children, haste ye, quit these altar stairs,</p>
<p class="poem">Take hence your suppliant wands, go summon hither</p>
<p class="poem">The Theban commons. With the god’s good help</p>
<p class="poem">Success is sure; ‘tis ruin if we fail.</p>
<p class="poem">[Exeunt OEDIPUS and CREON]</p>
</a><p class="poem1"><a id="page_10"></a><a id="page_11">PRIEST: Come, children, let us hence; these gracious words</a></p><a id="page_11">
<p class="poem">Forestall the very purpose of our suit.</p>
<p class="poem">And may the god who sent this oracle</p>
<p class="poem">Save us withal and rid us of this pest.</p>
<p class="poem">[Exeunt PRIEST and SUPPLIANTS]</p>
<p class="poem1">CHORUS:</p>
<p class="poem"><em class="italic">(Str. 1)</em></p>
<p class="poem">Sweet-voiced daughter of Zeus from thy gold-paved Pythian shrine</p>
<p class="poemi">Wafted to Thebes divine,</p>
<p class="poem">What dost thou bring me? My soul is racked and shivers with fear.</p>
<p class="poemi">(Healer of Delos, hear!)</p>
<p class="poem">Hast thou some pain unknown before,</p>
<p class="poem">Or with the circling years renewest a penance of yore?</p>
<p class="poem">Offspring of golden Hope, thou voice immortal, O tell me.</p>
<p class="poem1"><em class="italic">(Ant. 1)</em></p>
<p class="poem">First on Athene I call; O Zeus-born goddess, defend!</p>
<p class="poemi">Goddess and sister, befriend,</p>
<p class="poem">Artemis, Lady of Thebes, high-throned in the midst of our mart!</p>
<p class="poemi">Lord of the death-winged dart!</p>
<p class="poemi">Your threefold aid I crave</p>
<p class="poemi">From death and ruin our city to save.</p>
<p class="poem">If in the days of old when we nigh had perished, ye drave</p>
<p class="poem">From our land the fiery plague, be near us now and defend us!</p>
<p class="poem1"><em class="italic">(Str. 2)</em></p>
<p class="poem">Ah me, what countless woes are mine!</p>
<p class="poem">All our host is in decline;</p>
<p class="poem">Weaponless my spirit lies.</p>
</a><p class="poem"><a id="page_11"></a><a id="page_12">Earth her gracious fruits denies;</a></p><a id="page_12">
<p class="poem">Women wail in barren throes;</p>
<p class="poem">Life on life downstriken goes,</p>
<p class="poem">Swifter than the wind bird’s flight,</p>
<p class="poem">Swifter than the Fire-God’s might,</p>
<p class="poem">To the westering shores of Night.</p>
<p class="poem1"><em class="italic">(Ant. 2)</em></p>
<p class="poem">Wasted thus by death on death</p>
<p class="poem">All our city perisheth.</p>
<p class="poem">Corpses spread infection round;</p>
<p class="poem">None to tend or mourn is found.</p>
<p class="poem">Wailing on the altar stair</p>
<p class="poem">Wives and grandams rend the air—</p>
<p class="poem">Long-drawn moans and piercing cries</p>
<p class="poem">Blent with prayers and litanies.</p>
<p class="poem">Golden child of Zeus, O hear</p>
<p class="poem">Let thine angel face appear!</p>
<p class="poem1"><em class="italic">(Str. 3)</em></p>
<p class="poem">And grant that Ares whose hot breath I feel,</p>
<p class="poemi">Though without targe or steel</p>
<p class="poem">He stalks, whose voice is as the battle shout,</p>
<p class="poem">May turn in sudden rout,</p>
<p class="poem">To the unharbored Thracian waters sped,</p>
<p class="poemi">Or Amphitrite’s bed.</p>
<p class="poemi">For what night leaves undone,</p>
<p class="poemi">Smit by the morrow’s sun</p>
<p class="poem">Perisheth. Father Zeus, whose hand</p>
<p class="poem">Doth wield the lightning brand,</p>
<p class="poem">Slay him beneath thy levin bold, we pray,</p>
<p class="poemi">Slay him, O slay!</p>
</a><p class="poem1"><a id="page_12"></a><a id="page_13"><em class="italic">(Ant. 3)</em></a></p><a id="page_13">
<p class="poem">O that thine arrows too, Lycean King,</p>
<p class="poemi">From that taut bow’s gold string,</p>
<p class="poem">Might fly abroad, the champions of our rights;</p>
<p class="poemi">Yea, and the flashing lights</p>
<p class="poem">Of Artemis, wherewith the huntress sweeps</p>
<p class="poemi">Across the Lycian steeps.</p>
<p class="poem">Thee too I call with golden-snooded hair,</p>
<p class="poemi">Whose name our land doth bear,</p>
<p class="poem">Bacchus to whom thy Maenads Evoe shout;</p>
<p class="poemi">Come with thy bright torch, rout,</p>
<p class="poemi">Blithe god whom we adore,</p>
<p class="poemi">The god whom gods abhor.</p>
<p class="poem">[Enter OEDIPUS.]</p>
<p class="poem1">OEDIPUS: Ye pray; ‘tis well, but would ye hear my words</p>
<p class="poem">And heed them and apply the remedy,</p>
<p class="poem">Ye might perchance find comfort and relief.</p>
<p class="poem">Mind you, I speak as one who comes a stranger</p>
<p class="poem">To this report, no less than to the crime;</p>
<p class="poem">For how unaided could I track it far</p>
<p class="poem">Without a clue? Which lacking (for too late</p>
<p class="poem">Was I enrolled a citizen of Thebes)</p>
<p class="poem">This proclamation I address to all:—</p>
<p class="poem">Thebans, if any knows the man by whom</p>
<p class="poem">Laius, son of Labdacus, was slain,</p>
<p class="poem">I summon him to make clean shrift to me.</p>
<p class="poem">And if he shrinks, let him reflect that thus</p>
<p class="poem">Confessing he shall ‘scape the capital charge;</p>
<p class="poem">For the worst penalty that shall befall him</p>
<p class="poem">Is banishment—unscathed he shall depart.</p>
<p class="poem">But if an alien from a foreign land</p>
</a><p class="poem"><a id="page_13"></a><a id="page_14">Be known to any as the murderer,</a></p><a id="page_14">
<p class="poem">Let him who knows speak out, and he shall have</p>
<p class="poem">Due recompense from me and thanks to boot.</p>
<p class="poem">But if ye still keep silence, if through fear</p>
<p class="poem">For self or friends ye disregard my hest,</p>
<p class="poem">Hear what I then resolve; I lay my ban</p>
<p class="poem">On the assassin whosoe’er he be.</p>
<p class="poem">Let no man in this land, whereof I hold</p>
<p class="poem">The sovereign rule, harbor or speak to him;</p>
<p class="poem">Give him no part in prayer or sacrifice</p>
<p class="poem">Or lustral rites, but hound him from your homes.</p>
<p class="poem">For this is our defilement, so the god</p>
<p class="poem">Hath lately shown to me by oracles.</p>
<p class="poem">Thus as their champion I maintain the cause</p>
<p class="poem">Both of the god and of the murdered King.</p>
<p class="poem">And on the murderer this curse I lay</p>
<p class="poem">(On him and all the partners in his guilt):—</p>
<p class="poem">Wretch, may he pine in utter wretchedness!</p>
<p class="poem">And for myself, if with my privity</p>
<p class="poem">He gain admittance to my hearth, I pray</p>
<p class="poem">The curse I laid on others fall on me.</p>
<p class="poem">See that ye give effect to all my hest,</p>
<p class="poem">For my sake and the god’s and for our land,</p>
<p class="poem">A desert blasted by the wrath of heaven.</p>
<p class="poem">For, let alone the god’s express command,</p>
<p class="poem">It were a scandal ye should leave unpurged</p>
<p class="poem">The murder of a great man and your king,</p>
<p class="poem">Nor track it home. And now that I am lord,</p>
<p class="poem">Successor to his throne, his bed, his wife,</p>
<p class="poem">(And had he not been frustrate in the hope</p>
<p class="poem">Of issue, common children of one womb</p>
<p class="poem">Had forced a closer bond twixt him and me,</p>
</a><p class="poem"><a id="page_14"></a><a id="page_15">But Fate swooped down upon him), therefore I</a></p><a id="page_15">
<p class="poem">His blood-avenger will maintain his cause</p>
<p class="poem">As though he were my sire, and leave no stone</p>
<p class="poem">Unturned to track the assassin or avenge</p>
<p class="poem">The son of Labdacus, of Polydore,</p>
<p class="poem">Of Cadmus, and Agenor first of the race.</p>
<p class="poem">And for the disobedient thus I pray:</p>
<p class="poem">May the gods send them neither timely fruits</p>
<p class="poem">Of earth, nor teeming increase of the womb,</p>
<p class="poem">But may they waste and pine, as now they waste,</p>
<p class="poem">Aye and worse stricken; but to all of you,</p>
<p class="poem">My loyal subjects who approve my acts,</p>
<p class="poem">May Justice, our ally, and all the gods</p>
<p class="poem">Be gracious and attend you evermore.</p>
<p class="poem1">CHORUS: The oath thou profferest, sire, I take and swear.</p>
<p class="poem">I slew him not myself, nor can I name</p>
<p class="poem">The slayer. For the quest, ‘twere well, methinks</p>
<p class="poem">That Phoebus, who proposed the riddle, himself</p>
<p class="poem">Should give the answer—who the murderer was.</p>
<p class="poem1">OEDIPUS: Well argued; but no living man can hope</p>
<p class="poem">To force the gods to speak against their will.</p>
<p class="poem1">CHORUS: May I then say what seems next best to me?</p>
<p class="poem1">OEDIPUS: Aye, if there be a third best, tell it too.</p>
<p class="poem1">CHORUS: My liege, if any man sees eye to eye</p>
<p class="poem">With our lord Phoebus, ‘tis our prophet, lord</p>
<p class="poem">Teiresias; he of all men best might guide</p>
<p class="poem">A searcher of this matter to the light.</p>
</a><p class="poem1"><a id="page_15"></a><a id="page_16">OEDIPUS: Here too my zeal has nothing lagged, for twice</a></p><a id="page_16">
<p class="poem">At Creon’s instance have I sent to fetch him,</p>
<p class="poem">And long I marvel why he is not here.</p>
<p class="poem1">CHORUS: I mind me too of rumors long ago—</p>
<p class="poem">Mere gossip.</p>
<p class="poem1">OEDIPUS: Tell them, I would fain know all.</p>
<p class="poem1">CHORUS: ‘Twas said he fell by travelers.</p>
<p class="poem1">OEDIPUS: So I heard,</p>
<p class="poem">But none has seen the man who saw him fall.</p>
<p class="poem1">CHORUS: Well, if he knows what fear is, he will quail</p>
<p class="poem">And flee before the terror of thy curse.</p>
<p class="poem1">OEDIPUS: Words scare not him who blenches not at deeds.</p>
<p class="poem1">CHORUS: But here is one to arraign him. Lo, at length</p>
<p class="poem">They bring the god-inspired seer in whom</p>
<p class="poem">Above all other men is truth inborn.</p>
<p class="poem">[Enter TEIRESIAS, led by a boy.]</p>
<p class="poem1">OEDIPUS: Teiresias, seer who comprehendest all,</p>
<p class="poem">Lore of the wise and hidden mysteries,</p>
<p class="poem">High things of heaven and low things of the earth,</p>
<p class="poem">Thou knowest, though thy blinded eyes see naught,</p>
<p class="poem">What plague infects our city; and we turn</p>
<p class="poem">To thee, O seer, our one defense and shield.</p>
<p class="poem">The purport of the answer that the God</p>
<p class="poem">Returned to us who sought his oracle,</p>
</a><p class="poem"><a id="page_16"></a><a id="page_17">The messengers have doubtless told thee—how</a></p><a id="page_17">
<p class="poem">One course alone could rid us of the pest,</p>
<p class="poem">To find the murderers of Laius,</p>
<p class="poem">And slay them or expel them from the land.</p>
<p class="poem">Therefore begrudging neither augury</p>
<p class="poem">Nor other divination that is thine,</p>
<p class="poem">O save thyself, thy country, and thy king,</p>
<p class="poem">Save all from this defilement of blood shed.</p>
<p class="poem">On thee we rest. This is man’s highest end,</p>
<p class="poem">To others’ service all his powers to lend.</p>
<p class="poem1">TEIRESIAS: Alas, alas, what misery to be wise</p>
<p class="poem">When wisdom profits nothing! This old lore</p>
<p class="poem">I had forgotten; else I were not here.</p>
<p class="poem1">OEDIPUS: What ails thee? Why this melancholy mood?</p>
<p class="poem1">TEIRESIAS: Let me go home; prevent me not; ‘twere best</p>
<p class="poem">That thou shouldst bear thy burden and I mine.</p>
<p class="poem1">OEDIPUS: For shame! no true-born Theban patriot</p>
<p class="poem">Would thus withhold the word of prophecy.</p>
<p class="poem1">TEIRESIAS: Thy words, O king, are wide of the mark, and I</p>
<p class="poem">For fear lest I too trip like thee …</p>
<p class="poem1">OEDIPUS: Oh speak,</p>
<p class="poem">Withhold not, I adjure thee, if thou know’st,</p>
<p class="poem">Thy knowledge. We are all thy suppliants.</p>
<p class="poem1">TEIRESIAS: Aye, for ye all are witless, but my voice</p>
<p class="poem">Will ne’er reveal my miseries—or thine. <em class="italic"><span class="underline">2</span></em></p>
</a><p class="poem1"><a id="page_17"></a><a id="page_18">OEDIPUS: What then, thou knowest, and yet willst not speak!</a></p><a id="page_18">
<p class="poem">Wouldst thou betray us and destroy the State?</p>
<p class="poem1">TEIRESIAS: I will not vex myself nor thee. Why ask</p>
<p class="poem">Thus idly what from me thou shalt not learn?</p>
<p class="poem1">OEDIPUS: Monster! thy silence would incense a flint.</p>
<p class="poem">Will nothing loose thy tongue? Can nothing melt thee,</p>
<p class="poem">Or shake thy dogged taciturnity?</p>
<p class="poem1">TEIRESIAS: Thou blam’st my mood and seest not thine own</p>
<p class="poem">Wherewith thou art mated; no, thou taxest me.</p>
<p class="poem1">OEDIPUS: And who could stay his choler when he heard</p>
<p class="poem">How insolently thou dost flout the State?</p>
<p class="poem1">TEIRESIAS: Well, it will come what will, though I be mute.</p>
<p class="poem1">OEDIPUS: Since come it must, thy duty is to tell me.</p>
<p class="poem1">TEIRESIAS: I have no more to say; storm as thou willst,</p>
<p class="poem">And give the rein to all thy pent-up rage.</p>
<p class="poem1">OEDIPUS: Yea, I am wroth, and will not stint my words,</p>
<p class="poem">But speak my whole mind. Thou methinks thou art he,</p>
<p class="poem">Who planned the crime, aye, and performed it too,</p>
<p class="poem">All save the assassination; and if thou</p>
<p class="poem">Hadst not been blind, I had been sworn to boot</p>
<p class="poem">That thou alone didst do the bloody deed.</p>
<p class="poem1">TEIRESIAS: Is it so? Then I charge thee to abide</p>
<p class="poem">By thine own proclamation; from this day</p>
</a><p class="poem"><a id="page_18"></a><a id="page_19">Speak not to these or me. Thou art the man,</a></p><a id="page_19">
<p class="poem">Thou the accursed polluter of this land.</p>
<p class="poem1">OEDIPUS: Vile slanderer, thou blurtest forth these taunts,</p>
<p class="poem">And think’st forsooth as seer to go scot free.</p>
<p class="poem1">TEIRESIAS: Yea, I am free, strong in the strength of truth.</p>
<p class="poem1">OEDIPUS: Who was thy teacher? not methinks thy art.</p>
<p class="poem1">TEIRESIAS: Thou, goading me against my will to speak.</p>
<p class="poem1">OEDIPUS: What speech? repeat it and resolve my doubt.</p>
<p class="poem1">TEIRESIAS: Didst miss my sense wouldst thou goad me on?</p>
<p class="poem1">OEDIPUS: I but half caught thy meaning; say it again.</p>
<p class="poem1">TEIRESIAS: I say thou art the murderer of the man</p>
<p class="poem">Whose murderer thou pursuest.</p>
<p class="poem1">OEDIPUS: Thou shalt rue it</p>
<p class="poem">Twice to repeat so gross a calumny.</p>
<p class="poem1">TEIRESIAS: Must I say more to aggravate thy rage?</p>
<p class="poem1">OEDIPUS: Say all thou wilt; it will be but waste of breath.</p>
<p class="poem1">TEIRESIAS: I say thou livest with thy nearest kin</p>
<p class="poem">In infamy, unwitting in thy shame.</p>
<p class="poem1">OEDIPUS: Think’st thou for aye unscathed to wag thy tongue?</p>
</a><p class="poem1"><a id="page_19"></a><a id="page_20">TEIRESIAS: Yea, if the might of truth can aught prevail.</a></p><a id="page_20">
<p class="poem1">OEDIPUS: With other men, but not with thee, for thou</p>
<p class="poem">In ear, wit, eye, in everything art blind.</p>
<p class="poem1">TEIRESIAS: Poor fool to utter gibes at me which all</p>
<p class="poem">Here present will cast back on thee ere long.</p>
<p class="poem1">OEDIPUS: Offspring of endless Night, thou hast no power</p>
<p class="poem">O’er me or any man who sees the sun.</p>
<p class="poem1">TEIRESIAS: No, for thy weird is not to fall by me.</p>
<p class="poem">I leave to Apollo what concerns the god.</p>
<p class="poem1">OEDIPUS: Is this a plot of Creon, or thine own?</p>
<p class="poem1">TEIRESIAS: Not Creon, thou thyself art thine own bane.</p>
<p class="poem1">OEDIPUS: O wealth and empiry and skill by skill</p>
<p class="poem">Outwitted in the battlefield of life,</p>
<p class="poem">What spite and envy follow in your train!</p>
<p class="poem">See, for this crown the State conferred on me.</p>
<p class="poem">A gift, a thing I sought not, for this crown</p>
<p class="poem">The trusty Creon, my familiar friend,</p>
<p class="poem">Hath lain in wait to oust me and suborned</p>
<p class="poem">This mountebank, this juggling charlatan,</p>
<p class="poem">This tricksy beggar-priest, for gain alone</p>
<p class="poem">Keen-eyed, but in his proper art stone-blind.</p>
<p class="poem">Say, sirrah, hast thou ever proved thyself</p>
<p class="poem">A prophet? When the riddling Sphinx was here</p>
<p class="poem">Why hadst thou no deliverance for this folk?</p>
<p class="poem">And yet the riddle was not to be solved</p>
</a><p class="poem"><a id="page_20"></a><a id="page_21">By guess-work but required the prophet’s art;</a></p><a id="page_21">
<p class="poem">Wherein thou wast found lacking; neither birds</p>
<p class="poem">Nor sign from heaven helped thee, but I came,</p>
<p class="poem">The simple Oedipus; I stopped her mouth</p>
<p class="poem">By mother wit, untaught of auguries.</p>
<p class="poem">This is the man whom thou wouldst undermine,</p>
<p class="poem">In hope to reign with Creon in my stead.</p>
<p class="poem">Methinks that thou and thine abettor soon</p>
<p class="poem">Will rue your plot to drive the scapegoat out.</p>
<p class="poem">Thank thy grey hairs that thou hast still to learn</p>
<p class="poem">What chastisement such arrogance deserves.</p>
<p class="poem1">CHORUS: To us it seems that both the seer and thou,</p>
<p class="poem">O Oedipus, have spoken angry words.</p>
<p class="poem">This is no time to wrangle but consult</p>
<p class="poem">How best we may fulfill the oracle.</p>
<p class="poem1">TEIRESIAS: King as thou art, free speech at least is mine</p>
<p class="poem">To make reply; in this I am thy peer.</p>
<p class="poem">I own no lord but Loxias; him I serve</p>
<p class="poem">And ne’er can stand enrolled as Creon’s man.</p>
<p class="poem">Thus then I answer: since thou hast not spared</p>
<p class="poem">To twit me with my blindness—thou hast eyes,</p>
<p class="poem">Yet see’st not in what misery thou art fallen,</p>
<p class="poem">Nor where thou dwellest nor with whom for mate.</p>
<p class="poem">Dost know thy lineage? Nay, thou know’st it not,</p>
<p class="poem">And all unwitting art a double foe</p>
<p class="poem">To thine own kin, the living and the dead;</p>
<p class="poem">Aye and the dogging curse of mother and sire</p>
<p class="poem">One day shall drive thee, like a two-edged sword,</p>
<p class="poem">Beyond our borders, and the eyes that now</p>
<p class="poem">See clear shall henceforward endless night.</p>
</a><p class="poem"><a id="page_21"></a><a id="page_22">Ah whither shall thy bitter cry not reach,</a></p><a id="page_22">
<p class="poem">What crag in all Cithaeron but shall then</p>
<p class="poem">Reverberate thy wail, when thou hast found</p>
<p class="poem">With what a hymeneal thou wast borne</p>
<p class="poem">Home, but to no fair haven, on the gale!</p>
<p class="poem">Aye, and a flood of ills thou guessest not</p>
<p class="poem">Shall set thyself and children in one line.</p>
<p class="poem">Flout then both Creon and my words, for none</p>
<p class="poem">Of mortals shall be striken worse than thou.</p>
<p class="poem1">OEDIPUS: Must I endure this fellow’s insolence?</p>
<p class="poem">A murrain on thee! Get thee hence! Begone</p>
<p class="poem">Avaunt! and never cross my threshold more.</p>
<p class="poem1">TEIRESIAS: I ne’er had come hadst thou not bidden me.</p>
<p class="poem1">OEDIPUS: I know not thou wouldst utter folly, else</p>
<p class="poem">Long hadst thou waited to be summoned here.</p>
<p class="poem1">TEIRESIAS: Such am I—as it seems to thee a fool,</p>
<p class="poem">But to the parents who begat thee, wise.</p>
<p class="poem1">OEDIPUS: What sayest thou—“parents”? Who begat me, speak?</p>
<p class="poem1">TEIRESIAS: This day shall be thy birth-day, and thy grave.</p>
<p class="poem1">OEDIPUS: Thou lov’st to speak in riddles and dark words.</p>
<p class="poem1">TEIRESIAS: In reading riddles who so skilled as thou?</p>
<p class="poem1">OEDIPUS: Twit me with that wherein my greatness lies.</p>
</a><p class="poem1"><a id="page_22"></a><a id="page_23">TEIRESIAS: And yet this very greatness proved thy bane.</a></p><a id="page_23">
<p class="poem1">OEDIPUS: No matter if I saved the commonwealth.</p>
<p class="poem1">TEIRESIAS: ‘Tis time I left thee. Come, boy, take me home.</p>
<p class="poem1">OEDIPUS: Aye, take him quickly, for his presence irks</p>
<p class="poem">And lets me; gone, thou canst not plague me more.</p>
<p class="poem1">TEIRESIAS: I go, but first will tell thee why I came.</p>
<p class="poem">Thy frown I dread not, for thou canst not harm me.</p>
<p class="poem">Hear then: this man whom thou hast sought to arrest</p>
<p class="poem">With threats and warrants this long while, the wretch</p>
<p class="poem">Who murdered Laius—that man is here.</p>
<p class="poem">He passes for an alien in the land</p>
<p class="poem">But soon shall prove a Theban, native born.</p>
<p class="poem">And yet his fortune brings him little joy;</p>
<p class="poem">For blind of seeing, clad in beggar’s weeds,</p>
<p class="poem">For purple robes, and leaning on his staff,</p>
<p class="poem">To a strange land he soon shall grope his way.</p>
<p class="poem">And of the children, inmates of his home,</p>
<p class="poem">He shall be proved the brother and the sire,</p>
<p class="poem">Of her who bare him son and husband both,</p>
<p class="poem">Co-partner, and assassin of his sire.</p>
<p class="poem">Go in and ponder this, and if thou find</p>
<p class="poem">That I have missed the mark, henceforth declare</p>
<p class="poem">I have no wit nor skill in prophecy.</p>
<p class="poem">[Exeunt TEIRESIAS and OEDIPUS]</p>
<p class="poem1">CHORUS:</p>
<p class="poem"><em class="italic">(Str. 1)</em></p>
<p class="poem">Who is he by voice immortal named from Pythia’s rocky cell,</p>
</a><p class="poem"><a id="page_23"></a><a id="page_24">Doer of foul deeds of bloodshed, horrors that no tongue can tell?</a></p><a id="page_24">
<p class="poemi">A foot for flight he needs</p>
<p class="poemi">Fleeter than storm-swift steeds,</p>
<p class="poemi">For on his heels doth follow,</p>
<p class="poem">Armed with the lightnings of his Sire, Apollo.</p>
<p class="poemi">Like sleuth-hounds too</p>
<p class="poemi">The Fates pursue.</p>
<p class="poem1"><em class="italic">(Ant. 1)</em></p>
<p class="poem">Yea, but now flashed forth the summons from Parnassus’ snowy peak,</p>
<p class="poem">“Near and far the undiscovered doer of this murder seek!”</p>
<p class="poemi">Now like a sullen bull he roves</p>
<p class="poemi">Through forest brakes and upland groves,</p>
<p class="poemi">And vainly seeks to fly</p>
<p class="poemi">The doom that ever nigh</p>
<p class="poemi">Flits o’er his head,</p>
<p class="poem">Still by the avenging Phoebus sped,</p>
<p class="poemi">The voice divine,</p>
<p class="poemi">From Earth’s mid shrine.</p>
<p class="poem1"><em class="italic">(Str. 2)</em></p>
<p class="poem">Sore perplexed am I by the words of the master seer.</p>
<p class="poem">Are they true, are they false? I know not and bridle my tongue for fear,</p>
<p class="poem">Fluttered with vague surmise; nor present nor future is clear.</p>
<p class="poem">Quarrel of ancient date or in days still near know I none</p>
<p class="poem">Twixt the Labdacidan house and our ruler, Polybus’ son.</p>
<p class="poem">Proof is there none: how then can I challenge our King’s good name,</p>
<p class="poem">How in a blood-feud join for an untracked deed of shame?</p>
</a><p class="poem1"><a id="page_24"></a><a id="page_25"><em class="italic">(Ant. 2)</em></a></p><a id="page_25">
<p class="poem">All wise are Zeus and Apollo, and nothing is hid from their ken;</p>
<p class="poem">They are gods; and in wits a man may surpass his fellow men;</p>
<p class="poem">But that a mortal seer knows more than I know—where</p>
<p class="poem">Hath this been proven? Or how without sign assured, can I blame</p>
<p class="poem">Him who saved our State when the winged songstress came,</p>
<p class="poem">Tested and tried in the light of us all, like gold assayed?</p>
<p class="poem">How can I now assent when a crime is on Oedipus laid?</p>
<p class="poem1">CREON: Friends, countrymen, I learn King Oedipus</p>
<p class="poem">Hath laid against me a most grievous charge,</p>
<p class="poem">And come to you protesting. If he deems</p>
<p class="poem">That I have harmed or injured him in aught</p>
<p class="poem">By word or deed in this our present trouble,</p>
<p class="poem">I care not to prolong the span of life,</p>
<p class="poem">Thus ill-reputed; for the calumny</p>
<p class="poem">Hits not a single blot, but blasts my name,</p>
<p class="poem">If by the general voice I am denounced</p>
<p class="poem">False to the State and false by you my friends.</p>
<p class="poem1">CHORUS: This taunt, it well may be, was blurted out</p>
<p class="poem">In petulance, not spoken advisedly.</p>
<p class="poem1">CREON: Did any dare pretend that it was I</p>
<p class="poem">Prompted the seer to utter a forged charge?</p>
<p class="poem1">CHORUS: Such things were said; with what intent I know not.</p>
<p class="poem1">CREON: Were not his wits and vision all astray</p>
<p class="poem">When upon me he fixed this monstrous charge?</p>
<p class="poem1">CHORUS: I know not; to my sovereign’s acts I am blind.</p>
</a><p class="poem"><a id="page_25"></a><a id="page_26">But lo, he comes to answer for himself.</a></p><a id="page_26">
<p class="poem">[Enter OEDIPUS.]</p>
<p class="poem1">OEDIPUS: Sirrah, what mak’st thou here? Dost thou presume</p>
<p class="poem">To approach my doors, thou brazen-faced rogue,</p>
<p class="poem">My murderer and the filcher of my crown?</p>
<p class="poem">Come, answer this, didst thou detect in me</p>
<p class="poem">Some touch of cowardice or witlessness,</p>
<p class="poem">That made thee undertake this enterprise?</p>
<p class="poem">I seemed forsooth too simple to perceive</p>
<p class="poem">The serpent stealing on me in the dark,</p>
<p class="poem">Or else too weak to scotch it when I saw.</p>
<p class="poem">This thou art witless seeking to possess</p>
<p class="poem">Without a following or friends the crown,</p>
<p class="poem">A prize that followers and wealth must win.</p>
<p class="poem1">CREON: Attend me. Thou hast spoken, ‘tis my turn</p>
<p class="poem">To make reply. Then having heard me, judge.</p>
<p class="poem1">OEDIPUS: Thou art glib of tongue, but I am slow to learn</p>
<p class="poem">Of thee; I know too well thy venomous hate.</p>
<p class="poem1">CREON: First I would argue out this very point.</p>
<p class="poem1">OEDIPUS: O argue not that thou art not a rogue.</p>
<p class="poem1">CREON: If thou dost count a virtue stubbornness,</p>
<p class="poem">Unschooled by reason, thou art much astray.</p>
<p class="poem1">OEDIPUS: If thou dost hold a kinsman may be wronged,</p>
<p class="poem">And no pains follow, thou art much to seek.</p>
</a><p class="poem1"><a id="page_26"></a><a id="page_27">CREON: Therein thou judgest rightly, but this wrong</a></p><a id="page_27">
<p class="poem">That thou allegest—tell me what it is.</p>
<p class="poem1">OEDIPUS: Didst thou or didst thou not advise that I</p>
<p class="poem">Should call the priest?</p>
<p class="poem1">CREON: Yes, and I stand to it.</p>
<p class="poem1">OEDIPUS: Tell me how long is it since Laius …</p>
<p class="poem1">CREON: Since Laius …? I follow not thy drift.</p>
<p class="poem1">OEDIPUS: By violent hands was spirited away.</p>
<p class="poem1">CREON: In the dim past, a many years agone.</p>
<p class="poem1">OEDIPUS: Did the same prophet then pursue his craft?</p>
<p class="poem1">CREON: Yes, skilled as now and in no less repute.</p>
<p class="poem1">OEDIPUS: Did he at that time ever glance at me?</p>
<p class="poem1">CREON: Not to my knowledge, not when I was by.</p>
<p class="poem1">OEDIPUS: But was no search and inquisition made?</p>
<p class="poem1">CREON: Surely full quest was made, but nothing learnt.</p>
<p class="poem1">OEDIPUS: Why failed the seer to tell his story then?</p>
<p class="poem1">CREON: I know not, and not knowing hold my tongue.</p>
</a><p class="poem1"><a id="page_27"></a><a id="page_28">OEDIPUS: This much thou knowest and canst surely tell.</a></p><a id="page_28">
<p class="poem1">CREON: What’s mean’st thou? All I know I will declare.</p>
<p class="poem1">OEDIPUS: But for thy prompting never had the seer</p>
<p class="poem">Ascribed to me the death of Laius.</p>
<p class="poem1">CREON: If so he thou knowest best; but I</p>
<p class="poem">Would put thee to the question in my turn.</p>
<p class="poem1">OEDIPUS: Question and prove me murderer if thou canst.</p>
<p class="poem1">CREON: Then let me ask thee, didst thou wed my sister?</p>
<p class="poem1">OEDIPUS: A fact so plain I cannot well deny.</p>
<p class="poem1">CREON: And as thy consort queen she shares the throne?</p>
<p class="poem1">OEDIPUS: I grant her freely all her heart desires.</p>
<p class="poem1">CREON: And with you twain I share the triple rule?</p>
<p class="poem1">OEDIPUS: Yea, and it is that proves thee a false friend.</p>
<p class="poem1">CREON: Not so, if thou wouldst reason with thyself,</p>
<p class="poem">As I with myself. First, I bid thee think,</p>
<p class="poem">Would any mortal choose a troubled reign</p>
<p class="poem">Of terrors rather than secure repose,</p>
<p class="poem">If the same power were given him? As for me,</p>
<p class="poem">I have no natural craving for the name</p>
<p class="poem">Of king, preferring to do kingly deeds,</p>
<p class="poem">And so thinks every sober-minded man.</p>
</a><p class="poem"><a id="page_28"></a><a id="page_29">Now all my needs are satisfied through thee,</a></p><a id="page_29">
<p class="poem">And I have naught to fear; but were I king,</p>
<p class="poem">My acts would oft run counter to my will.</p>
<p class="poem">How could a title then have charms for me</p>
<p class="poem">Above the sweets of boundless influence?</p>
<p class="poem">I am not so infatuate as to grasp</p>
<p class="poem">The shadow when I hold the substance fast.</p>
<p class="poem">Now all men cry me Godspeed! wish me well,</p>
<p class="poem">And every suitor seeks to gain my ear,</p>
<p class="poem">If he would hope to win a grace from thee.</p>
<p class="poem">Why should I leave the better, choose the worse?</p>
<p class="poem">That were sheer madness, and I am not mad.</p>
<p class="poem">No such ambition ever tempted me,</p>
<p class="poem">Nor would I have a share in such intrigue.</p>
<p class="poem">And if thou doubt me, first to Delphi go,</p>
<p class="poem">There ascertain if my report was true</p>
<p class="poem">Of the god’s answer; next investigate</p>
<p class="poem">If with the seer I plotted or conspired,</p>
<p class="poem">And if it prove so, sentence me to death,</p>
<p class="poem">Not by thy voice alone, but mine and thine.</p>
<p class="poem">But O condemn me not, without appeal,</p>
<p class="poem">On bare suspicion. ‘Tis not right to adjudge</p>
<p class="poem">Bad men at random good, or good men bad.</p>
<p class="poem">I would as lief a man should cast away</p>
<p class="poem">The thing he counts most precious, his own life,</p>
<p class="poem">As spurn a true friend. Thou wilt learn in time</p>
<p class="poem">The truth, for time alone reveals the just;</p>
<p class="poem">A villain is detected in a day.</p>
<p class="poem1">CHORUS: To one who walketh warily his words</p>
<p class="poem">Commend themselves; swift counsels are not sure.</p>
</a><p class="poem1"><a id="page_29"></a><a id="page_30">OEDIPUS: When with swift strides the stealthy plotter stalks</a></p><a id="page_30">
<p class="poem">I must be quick too with my counterplot.</p>
<p class="poem">To wait his onset passively, for him</p>
<p class="poem">Is sure success, for me assured defeat.</p>
<p class="poem1">CREON: What then’s thy will? To banish me the land?</p>
<p class="poem1">OEDIPUS: I would not have thee banished, no, but dead,</p>
<p class="poem">That men may mark the wages envy reaps.</p>
<p class="poem1">CREON: I see thou wilt not yield, nor credit me.</p>
<p class="poem1">OEDIPUS: [None but a fool would credit such as thou.] <em class="italic"><span class="underline">3</span></em></p>
<p class="poem1">CREON: Thou art not wise.</p>
<p class="poem1">OEDIPUS: Wise for myself at least.</p>
<p class="poem1">CREON: Why not for me too?</p>
<p class="poem1">OEDIPUS: Why for such a knave?</p>
<p class="poem1">CREON: Suppose thou lackest sense.</p>
<p class="poem1">OEDIPUS: Yet kings must rule.</p>
<p class="poem1">CREON: Not if they rule ill.</p>
<p class="poem1">OEDIPUS: Oh my Thebans, hear him!</p>
<p class="poem1">CREON: Thy Thebans? am not I a Theban too?</p>
</a><p class="poem1"><a id="page_30"></a><a id="page_31">CHORUS: Cease, princes; lo there comes, and none too soon,</a></p><a id="page_31">
<p class="poem">Jocasta from the palace. Who so fit</p>
<p class="poem">As peacemaker to reconcile your feud?</p>
<p class="poem">[Enter JOCASTA.]</p>
<p class="poem1">JOCASTA: Misguided princes, why have ye upraised</p>
<p class="poem">This wordy wrangle? Are ye not ashamed,</p>
<p class="poem">While the whole land lies striken, thus to voice</p>
<p class="poem">Your private injuries? Go in, my lord;</p>
<p class="poem">Go home, my brother, and forebear to make</p>
<p class="poem">A public scandal of a petty grief.</p>
<p class="poem1">CREON: My royal sister, Oedipus, thy lord,</p>
<p class="poem">Hath bid me choose (O dread alternative!)</p>
<p class="poem">An outlaw’s exile or a felon’s death.</p>
<p class="poem1">OEDIPUS: Yes, lady; I have caught him practicing</p>
<p class="poem">Against my royal person his vile arts.</p>
<p class="poem1">CREON: May I ne’er speed but die accursed, if I</p>
<p class="poem">In any way am guilty of this charge.</p>
<p class="poem1">JOCASTA: Believe him, I adjure thee, Oedipus,</p>
<p class="poem">First for his solemn oath’s sake, then for mine,</p>
<p class="poem">And for thine elders’ sake who wait on thee.</p>
<p class="poem1">CHORUS:</p>
<p class="poem"><em class="italic">(Str. 1)</em></p>
<p class="poem">Hearken, King, reflect, we pray thee, but not stubborn but relent.</p>
<p class="poem1">OEDIPUS: Say to what should I consent?</p>
</a><p class="poem1"><a id="page_31"></a><a id="page_32">CHORUS: Respect a man whose probity and troth</a></p><a id="page_32">
<p class="poem">Are known to all and now confirmed by oath.</p>
<p class="poem1">OEDIPUS: Dost know what grace thou cravest?</p>
<p class="poem1">CHORUS: Yea, I know.</p>
<p class="poem1">OEDIPUS: Declare it then and make thy meaning plain.</p>
<p class="poem1">CHORUS: Brand not a friend whom babbling tongues assail;</p>
<p class="poem">Let not suspicion ‘gainst his oath prevail.</p>
<p class="poem1">OEDIPUS: Bethink you that in seeking this ye seek</p>
<p class="poem">In very sooth my death or banishment?</p>
<p class="poem1">CHORUS: No, by the leader of the host divine!</p>
<p class="poem"><em class="italic">(Str. 2)</em></p>
<p class="poem">Witness, thou Sun, such thought was never mine,</p>
<p class="poem">Unblest, unfriended may I perish,</p>
<p class="poem">If ever I such wish did cherish!</p>
<p class="poem">But O my heart is desolate</p>
<p class="poem">Musing on our striken State,</p>
<p class="poem">Doubly fall’n should discord grow</p>
<p class="poem">Twixt you twain, to crown our woe.</p>
<p class="poem1">OEDIPUS: Well, let him go, no matter what it cost me,</p>
<p class="poem">Or certain death or shameful banishment,</p>
<p class="poem">For your sake I relent, not his; and him,</p>
<p class="poem">Where’er he be, my heart shall still abhor.</p>
<p class="poem1">CREON: Thou art as sullen in thy yielding mood</p>
<p class="poem">As in thine anger thou wast truculent.</p>
</a><p class="poem"><a id="page_32"></a><a id="page_33">Such tempers justly plague themselves the most.</a></p><a id="page_33">
<p class="poem1">OEDIPUS: Leave me in peace and get thee gone.</p>
<p class="poem1">CREON: I go,</p>
<p class="poem">By thee misjudged, but justified by these.</p>
<p class="poem">[Exeunt CREON]</p>
<p class="poem1">CHORUS:</p>
<p class="poem"><em class="italic">(Ant. 1)</em></p>
<p class="poem">Lady, lead indoors thy consort; wherefore longer here delay?</p>
<p class="poem1">JOCASTA: Tell me first how rose the fray.</p>
<p class="poem1">CHORUS: Rumors bred unjust suspicious and injustice rankles sore.</p>
<p class="poem1">JOCASTA: Were both at fault?</p>
<p class="poem1">CHORUS: Both.</p>
<p class="poem1">JOCASTA: What was the tale?</p>
<p class="poem1">CHORUS: Ask me no more. The land is sore distressed;</p>
<p class="poem">‘Twere better sleeping ills to leave at rest.</p>
<p class="poem1">OEDIPUS: Strange counsel, friend! I know thou mean’st me well,</p>
<p class="poem">And yet would’st mitigate and blunt my zeal.</p>
<p class="poem1">CHORUS:</p>
<p class="poem"><em class="italic">(Ant. 2)</em></p>
</a><p class="poem"><a id="page_33"></a><a id="page_34">King, I say it once again,</a></p><a id="page_34">
<p class="poem">Witless were I proved, insane,</p>
<p class="poem">If I lightly put away</p>
<p class="poem">Thee my country’s prop and stay,</p>
<p class="poem">Pilot who, in danger sought,</p>
<p class="poem">To a quiet haven brought</p>
<p class="poem">Our distracted State; and now</p>
<p class="poem">Who can guide us right but thou?</p>
<p class="poem1">JOCASTA: Let me too, I adjure thee, know, O king,</p>
<p class="poem">What cause has stirred this unrelenting wrath.</p>
<p class="poem1">OEDIPUS: I will, for thou art more to me than these.</p>
<p class="poem">Lady, the cause is Creon and his plots.</p>
<p class="poem1">JOCASTA: But what provoked the quarrel? make this clear.</p>
<p class="poem1">OEDIPUS: He points me out as Laius’ murderer.</p>
<p class="poem1">JOCASTA: Of his own knowledge or upon report?</p>
<p class="poem1">OEDIPUS: He is too cunning to commit himself,</p>
<p class="poem">And makes a mouthpiece of a knavish seer.</p>
<p class="poem1">JOCASTA: Then thou mayest ease thy conscience on that score.</p>
<p class="poem">Listen and I’ll convince thee that no man</p>
<p class="poem">Hath scot or lot in the prophetic art.</p>
<p class="poem">Here is the proof in brief. An oracle</p>
<p class="poem">Once came to Laius (I will not say</p>
<p class="poem">‘Twas from the Delphic god himself, but from</p>
<p class="poem">His ministers) declaring he was doomed</p>
<p class="poem">To perish by the hand of his own son,</p>
</a><p class="poem"><a id="page_34"></a><a id="page_35">A child that should be born to him by me.</a></p><a id="page_35">
<p class="poem">Now Laius—so at least report affirmed—</p>
<p class="poem">Was murdered on a day by highwaymen,</p>
<p class="poem">No natives, at a spot where three roads meet.</p>
<p class="poem">As for the child, it was but three days old,</p>
<p class="poem">When Laius, its ankles pierced and pinned</p>
<p class="poem">Together, gave it to be cast away</p>
<p class="poem">By others on the trackless mountain side.</p>
<p class="poem">So then Apollo brought it not to pass</p>
<p class="poem">The child should be his father’s murderer,</p>
<p class="poem">Or the dread terror find accomplishment,</p>
<p class="poem">And Laius be slain by his own son.</p>
<p class="poem">Such was the prophet’s horoscope. O king,</p>
<p class="poem">Regard it not. Whate’er the god deems fit</p>
<p class="poem">To search, himself unaided will reveal.</p>
<p class="poem1">OEDIPUS: What memories, what wild tumult of the soul</p>
<p class="poem">Came o’er me, lady, as I heard thee speak!</p>
<p class="poem1">JOCASTA: What mean’st thou? What has shocked and startled thee?</p>
<p class="poem1">OEDIPUS: Methought I heard thee say that Laius</p>
<p class="poem">Was murdered at the meeting of three roads.</p>
<p class="poem1">JOCASTA: So ran the story that is current still.</p>
<p class="poem1">OEDIPUS: Where did this happen? Dost thou know the place?</p>
<p class="poem1">JOCASTA: Phocis the land is called; the spot is where</p>
<p class="poem">Branch roads from Delphi and from Daulis meet.</p>
</a><p class="poem1"><a id="page_35"></a><a id="page_36">OEDIPUS: And how long is it since these things befell?</a></p><a id="page_36">
<p class="poem1">JOCASTA: ‘Twas but a brief while were thou wast proclaimed</p>
<p class="poem1">Our country’s ruler that the news was brought.</p>
<p class="poem1">OEDIPUS: O Zeus, what hast thou willed to do with me!</p>
<p class="poem1">JOCASTA: What is it, Oedipus, that moves thee so?</p>
<p class="poem1">OEDIPUS: Ask me not yet; tell me the build and height</p>
<p class="poem">Of Laius? Was he still in manhood’s prime?</p>
<p class="poem">JOCASTA: Tall was he, and his hair was lightly strewn</p>
<p class="poem">With silver; and not unlike thee in form.</p>
<p class="poem1">OEDIPUS: O woe is me! Mehtinks unwittingly</p>
<p class="poem">I laid but now a dread curse on myself.</p>
<p class="poem1">JOCASTA: What say’st thou? When I look upon thee, my king,</p>
<p class="poem">I tremble.</p>
<p class="poem1">OEDIPUS: ‘Tis a dread presentiment</p>
<p class="poem">That in the end the seer will prove not blind.</p>
<p class="poem">One further question to resolve my doubt.</p>
<p class="poem1">JOCASTA: I quail; but ask, and I will answer all.</p>
<p class="poem1">OEDIPUS: Had he but few attendants or a train</p>
<p class="poem">Of armed retainers with him, like a prince?</p>
<p class="poem1">JOCASTA: They were but five in all, and one of them</p>
<p class="poem">A herald; Laius in a mule-car rode.</p>
</a><p class="poem1"><a id="page_36"></a><a id="page_37">OEDIPUS: Alas! ‘tis clear as noonday now. But say,</a></p><a id="page_37">
<p class="poem">Lady, who carried this report to Thebes?</p>
<p class="poem1">JOCASTA: A serf, the sole survivor who returned.</p>
<p class="poem1">OEDIPUS: Haply he is at hand or in the house?</p>
<p class="poem1">JOCASTA: No, for as soon as he returned and found</p>
<p class="poem">Thee reigning in the stead of Laius slain,</p>
<p class="poem">He clasped my hand and supplicated me</p>
<p class="poem">To send him to the alps and pastures, where</p>
<p class="poem">He might be farthest from the sight of Thebes.</p>
<p class="poem">And so I sent him. ‘Twas an honest slave</p>
<p class="poem">And well deserved some better recompense.</p>
<p class="poem1">OEDIPUS: Fetch him at once. I fain would see the man.</p>
<p class="poem1">JOCASTA: He shall be brought; but wherefore summon him?</p>
<p class="poem1">OEDIPUS: Lady, I fear my tongue has overrun</p>
<p class="poem">Discretion; therefore I would question him.</p>
<p class="poem1">JOCASTA: Well, he shall come, but may not I too claim</p>
<p class="poem">To share the burden of thy heart, my king?</p>
<p class="poem1">OEDIPUS: And thou shalt not be frustrate of thy wish.</p>
<p class="poem">Now my imaginings have gone so far.</p>
<p class="poem">Who has a higher claim that thou to hear</p>
<p class="poem">My tale of dire adventures? Listen then.</p>
<p class="poem">My sire was Polybus of Corinth, and</p>
<p class="poem">My mother Merope, a Dorian;</p>
<p class="poem">And I was held the foremost citizen,</p>
</a><p class="poem"><a id="page_37"></a><a id="page_38">Till a strange thing befell me, strange indeed,</a></p><a id="page_38">
<p class="poem">Yet scarce deserving all the heat it stirred.</p>
<p class="poem">A roisterer at some banquet, flown with wine,</p>
<p class="poem">Shouted “Thou art not true son of thy sire.”</p>
<p class="poem">It irked me, but I stomached for the nonce</p>
<p class="poem">The insult; on the morrow I sought out</p>
<p class="poem">My mother and my sire and questioned them.</p>
<p class="poem">They were indignant at the random slur</p>
<p class="poem">Cast on my parentage and did their best</p>
<p class="poem">To comfort me, but still the venomed barb</p>
<p class="poem">Rankled, for still the scandal spread and grew.</p>
<p class="poem">So privily without their leave I went</p>
<p class="poem">To Delphi, and Apollo sent me back</p>
<p class="poem">Baulked of the knowledge that I came to seek.</p>
<p class="poem">But other grievous things he prophesied,</p>
<p class="poem">Woes, lamentations, mourning, portents dire;</p>
<p class="poem">To wit I should defile my mother’s bed</p>
<p class="poem">And raise up seed too loathsome to behold,</p>
<p class="poem">And slay the father from whose loins I sprang.</p>
<p class="poem">Then, lady,—thou shalt hear the very truth—</p>
<p class="poem">As I drew near the triple-branching roads,</p>
<p class="poem">A herald met me and a man who sat</p>
<p class="poem">In a car drawn by colts—as in thy tale—</p>
<p class="poem">The man in front and the old man himself</p>
<p class="poem">Threatened to thrust me rudely from the path,</p>
<p class="poem">Then jostled by the charioteer in wrath</p>
<p class="poem">I struck him, and the old man, seeing this,</p>
<p class="poem">Watched till I passed and from his car brought down</p>
<p class="poem">Full on my head the double-pointed goad.</p>
<p class="poemi">Yet was I quits with him and more; one stroke</p>
<p class="poem">Of my good staff sufficed to fling him clean</p>
<p class="poem">Out of the chariot seat and laid him prone.</p>
</a><p class="poem"><a id="page_38"></a><a id="page_39">And so I slew them every one. But if</a></p><a id="page_39">
<p class="poem">Betwixt this stranger there was aught in common</p>
<p class="poem">With Laius, who more miserable than I,</p>
<p class="poem">What mortal could you find more god-abhorred?</p>
<p class="poem">Wretch whom no sojourner, no citizen</p>
<p class="poem">May harbor or address, whom all are bound</p>
<p class="poem">To harry from their homes. And this same curse</p>
<p class="poem">Was laid on me, and laid by none but me.</p>
<p class="poem">Yea with these hands all gory I pollute</p>
<p class="poem">The bed of him I slew. Say, am I vile?</p>
<p class="poem">Am I not utterly unclean, a wretch</p>
<p class="poem">Doomed to be banished, and in banishment</p>
<p class="poem">Forgo the sight of all my dearest ones,</p>
<p class="poem">And never tread again my native earth;</p>
<p class="poem">Or else to wed my mother and slay my sire,</p>
<p class="poem">Polybus, who begat me and upreared?</p>
<p class="poem">If one should say, this is the handiwork</p>
<p class="poem">Of some inhuman power, who could blame</p>
<p class="poem">His judgment? But, ye pure and awful gods,</p>
<p class="poem">Forbid, forbid that I should see that day!</p>
<p class="poem">May I be blotted out from living men</p>
<p class="poem">Ere such a plague spot set on me its brand!</p>
<p class="poem1">CHORUS: We too, O king, are troubled; but till thou</p>
<p class="poem">Hast questioned the survivor, still hope on.</p>
<p class="poem1">OEDIPUS: My hope is faint, but still enough survives</p>
<p class="poem">To bid me bide the coming of this herd.</p>
<p class="poem1">JOCASTA: Suppose him here, what wouldst thou learn of him?</p>
<p class="poem1">OEDIPUS: I’ll tell thee, lady; if his tale agrees</p>
</a><p class="poem"><a id="page_39"></a><a id="page_40">With thine, I shall have ‘scaped calamity.</a></p><a id="page_40">
<p class="poem1">JOCASTA: And what of special import did I say?</p>
<p class="poem1">OEDIPUS: In thy report of what the herdsman said</p>
<p class="poem">Laius was slain by robbers; now if he</p>
<p class="poem">Still speaks of robbers, not a robber, I</p>
<p class="poem">Slew him not; “one” with “many” cannot square.</p>
<p class="poem">But if he says one lonely wayfarer,</p>
<p class="poem">The last link wanting to my guilt is forged.</p>
<p class="poem1">JOCASTA: Well, rest assured, his tale ran thus at first,</p>
<p class="poem">Nor can he now retract what then he said;</p>
<p class="poem">Not I alone but all our townsfolk heard it.</p>
<p class="poem">E’en should he vary somewhat in his story,</p>
<p class="poem">He cannot make the death of Laius</p>
<p class="poem">In any wise jump with the oracle.</p>
<p class="poem">For Loxias said expressly he was doomed</p>
<p class="poem">To die by my child’s hand, but he, poor babe,</p>
<p class="poem">He shed no blood, but perished first himself.</p>
<p class="poem">So much for divination. Henceforth I</p>
<p class="poem">Will look for signs neither to right nor left.</p>
<p class="poem1">OEDIPUS: Thou reasonest well. Still I would have thee send</p>
<p class="poem">And fetch the bondsman hither. See to it.</p>
<p class="poem1">JOCASTA: That will I straightway. Come, let us within.</p>
<p class="poem">I would do nothing that my lord mislikes.</p>
<p class="poem">[Exeunt OEDIPUS and JOCASTA]</p>
<p class="poem1">CHORUS</p>
<p class="poem"><em class="italic">(Str. 1)</em></p>
</a><p class="poem"><a id="page_40"></a><a id="page_41">My lot be still to lead</a></p><a id="page_41">
<p class="poemi">The life of innocence and fly</p>
<p class="poem">Irreverence in word or deed,</p>
<p class="poemi">To follow still those laws ordained on high</p>
<p class="poem">Whose birthplace is the bright ethereal sky</p>
<p class="poemi">No mortal birth they own,</p>
<p class="poemi">Olympus their progenitor alone:</p>
<p class="poem">Ne’er shall they slumber in oblivion cold,</p>
<p class="poem">The god in them is strong and grows not old.</p>
<p class="poem1"><em class="italic">(Ant. 1)</em></p>
<p class="poemi">Of insolence is bred</p>
<p class="poem">The tyrant; insolence full blown,</p>
<p class="poemi">With empty riches surfeited,</p>
<p class="poem">Scales the precipitous height and grasps the throne.</p>
<p class="poemi">Then topples o’er and lies in ruin prone;</p>
<p class="poemi">No foothold on that dizzy steep.</p>
<p class="poem">But O may Heaven the true patriot keep</p>
<p class="poem">Who burns with emulous zeal to serve the State.</p>
<p class="poem">God is my help and hope, on him I wait.</p>
<p class="poem1"><em class="italic">(Str. 2)</em></p>
<p class="poem">But the proud sinner, or in word or deed,</p>
<p class="poemi">That will not Justice heed,</p>
<p class="poemi">Nor reverence the shrine</p>
<p class="poemi">Of images divine,</p>
<p class="poem">Perdition seize his vain imaginings,</p>
<p class="poemi">If, urged by greed profane,</p>
<p class="poemi">He grasps at ill-got gain,</p>
<p class="poem">And lays an impious hand on holiest things.</p>
<p class="poemi">Who when such deeds are done</p>
<p class="poemi">Can hope heaven’s bolts to shun?</p>
</a><p class="poem"><a id="page_41"></a><a id="page_42">If sin like this to honor can aspire,</a></p><a id="page_42">
<p class="poem">Why dance I still and lead the sacred choir?</p>
<p class="poem1"><em class="italic">(Ant. 2)</em></p>
<p class="poem">No more I’ll seek earth’s central oracle,</p>
<p class="poemi">Or Abae’s hallowed cell,</p>
<p class="poemi">Nor to Olympia bring</p>
<p class="poemi">My votive offering.</p>
<p class="poem">If before all God’s truth be not bade plain.</p>
<p class="poemi">O Zeus, reveal thy might,</p>
<p class="poemi">King, if thou’rt named aright</p>
<p class="poem">Omnipotent, all-seeing, as of old;</p>
<p class="poemi">For Laius is forgot;</p>
<p class="poemi">His weird, men heed it not;</p>
<p class="poem">Apollo is forsook and faith grows cold.</p>
<p class="poem">[Enter JOCASTA.]</p>
<p class="poem1">JOCASTA: My lords, ye look amazed to see your queen</p>
<p class="poem">With wreaths and gifts of incense in her hands.</p>
<p class="poem">I had a mind to visit the high shrines,</p>
<p class="poem">For Oedipus is overwrought, alarmed</p>
<p class="poem">With terrors manifold. He will not use</p>
<p class="poem">His past experience, like a man of sense,</p>
<p class="poem">To judge the present need, but lends an ear</p>
<p class="poem">To any croaker if he augurs ill.</p>
<p class="poem">Since then my counsels naught avail, I turn</p>
<p class="poem">To thee, our present help in time of trouble,</p>
<p class="poem">Apollo, Lord Lycean, and to thee</p>
<p class="poem">My prayers and supplications here I bring.</p>
<p class="poem">Lighten us, lord, and cleanse us from this curse!</p>
<p class="poem">For now we all are cowed like mariners</p>
<p class="poem">Who see their helmsman dumbstruck in the storm.</p>
</a><p class="poem"><a id="page_42"></a><a id="page_43">[Enter Corinthian MESSENGER.]</a></p><a id="page_43">
<p class="poem1">MESSENGER: My masters, tell me where the palace is</p>
<p class="poem">Of Oedipus; or better, where’s the king.</p>
<p class="poem1">CHORUS: Here is the palace and he bides within;</p>
<p class="poem">This is his queen the mother of his children.</p>
<p class="poem1">MESSENGER: All happiness attend her and the house,</p>
<p class="poem">Blessed is her husband and her marriage-bed.</p>
<p class="poem1">JOCASTA: My greetings to thee, stranger; thy fair words</p>
<p class="poem">Deserve a like response. But tell me why</p>
<p class="poem">Thou comest—what thy need or what thy news.</p>
<p class="poem1">MESSENGER: Good for thy consort and the royal house.</p>
<p class="poem1">JOCASTA: What may it be? Whose messenger art thou?</p>
<p class="poem1">MESSENGER: The Isthmian commons have resolved to make</p>
<p class="poem">Thy husband king—so ‘twas reported there.</p>
<p class="poem1">JOCASTA: What! is not aged Polybus still king?</p>
<p class="poem1">MESSENGER: No, verily; he’s dead and in his grave.</p>
<p class="poem1">JOCASTA: What! is he dead, the sire of Oedipus?</p>
<p class="poem1">MESSENGER: If I speak falsely, may I die myself.</p>
<p class="poem1">JOCASTA: Quick, maiden, bear these tidings to my lord.</p>
<p class="poem">Ye god-sent oracles, where stand ye now!</p>
</a><p class="poem"><a id="page_43"></a><a id="page_44">This is the man whom Oedipus long shunned,</a></p><a id="page_44">
<p class="poem">In dread to prove his murderer; and now</p>
<p class="poem">He dies in nature’s course, not by his hand.</p>
<p class="poem">[Enter OEDIPUS.]</p>
<p class="poem1">OEDIPUS: My wife, my queen, Jocasta, why hast thou</p>
<p class="poem">Summoned me from my palace?</p>
<p class="poem1">JOCASTA: Hear this man,</p>
<p class="poem">And as thou hearest judge what has become</p>
<p class="poem">Of all those awe-inspiring oracles.</p>
<p class="poem1">OEDIPUS: Who is this man, and what his news for me?</p>
<p class="poem1">JOCASTA: He comes from Corinth and his message this:</p>
<p class="poem">Thy father Polybus hath passed away.</p>
<p class="poem1">OEDIPUS: What? let me have it, stranger, from thy mouth.</p>
<p class="poem1">MESSENGER: If I must first make plain beyond a doubt</p>
<p class="poem">My message, know that Polybus is dead.</p>
<p class="poem1">OEDIPUS: By treachery, or by sickness visited?</p>
<p class="poem1">MESSENGER: One touch will send an old man to his rest.</p>
<p class="poem1">OEDIPUS: So of some malady he died, poor man.</p>
<p class="poem1">MESSENGER: Yes, having measured the full span of years.</p>
<p class="poem1">OEDIPUS: Out on it, lady! why should one regard</p>
<p class="poem">The Pythian hearth or birds that scream i’ the air?</p>
</a><p class="poem"><a id="page_44"></a><a id="page_45">Did they not point at me as doomed to slay</a></p><a id="page_45">
<p class="poem">My father? but he’s dead and in his grave</p>
<p class="poem">And here am I who ne’er unsheathed a sword;</p>
<p class="poem">Unless the longing for his absent son</p>
<p class="poem">Killed him and so I slew him in a sense.</p>
<p class="poem">But, as they stand, the oracles are dead—</p>
<p class="poem">Dust, ashes, nothing, dead as Polybus.</p>
<p class="poem1">JOCASTA: Say, did not I foretell this long ago?</p>
<p class="poem1">OEDIPUS: Thou didst: but I was misled by my fear.</p>
<p class="poem1">JOCASTA: Then let I no more weigh upon thy soul.</p>
<p class="poem1">OEDIPUS: Must I not fear my mother’s marriage bed.</p>
<p class="poem1">JOCASTA: Why should a mortal man, the sport of chance,</p>
<p class="poem">With no assured foreknowledge, be afraid?</p>
<p class="poem">Best live a careless life from hand to mouth.</p>
<p class="poem">This wedlock with thy mother fear not thou.</p>
<p class="poem">How oft it chances that in dreams a man</p>
<p class="poem">Has wed his mother! He who least regards</p>
<p class="poem">Such brainsick phantasies lives most at ease.</p>
<p class="poem1">OEDIPUS: I should have shared in full thy confidence,</p>
<p class="poem">Were not my mother living; since she lives</p>
<p class="poem">Though half convinced I still must live in dread.</p>
<p class="poem1">JOCASTA: And yet thy sire’s death lights out darkness much.</p>
<p class="poem1">OEDIPUS: Much, but my fear is touching her who lives.</p>
</a><p class="poem1"><a id="page_45"></a><a id="page_46">MESSENGER: Who may this woman be whom thus you fear?</a></p><a id="page_46">
<p class="poem1">OEDIPUS: Merope, stranger, wife of Polybus.</p>
<p class="poem1">MESSENGER: And what of her can cause you any fear?</p>
<p class="poem1">OEDIPUS: A heaven-sent oracle of dread import.</p>
<p class="poem1">MESSENGER: A mystery, or may a stranger hear it?</p>
<p class="poem1">OEDIPUS: Aye, ‘tis no secret. Loxias once foretold</p>
<p class="poem">That I should mate with mine own mother, and shed</p>
<p class="poem">With my own hands the blood of my own sire.</p>
<p class="poem">Hence Corinth was for many a year to me</p>
<p class="poem">A home distant; and I trove abroad,</p>
<p class="poem">But missed the sweetest sight, my parents’ face.</p>
<p class="poem1">MESSENGER: Was this the fear that exiled thee from home?</p>
<p class="poem1">OEDIPUS: Yea, and the dread of slaying my own sire.</p>
<p class="poem1">MESSENGER: Why, since I came to give thee pleasure, King,</p>
<p class="poem">Have I not rid thee of this second fear?</p>
<p class="poem1">OEDIPUS: Well, thou shalt have due guerdon for thy pains.</p>
<p class="poem1">MESSENGER: Well, I confess what chiefly made me come</p>
<p class="poem">Was hope to profit by thy coming home.</p>
<p class="poem1">OEDIPUS: Nay, I will ne’er go near my parents more.</p>
<p class="poem1">MESSENGER: My son, ‘tis plain, thou know’st not what thou doest.</p>
</a><p class="poem1"><a id="page_46"></a><a id="page_47">OEDIPUS: How so, old man? For heaven’s sake tell me all.</a></p><a id="page_47">
<p class="poem1">MESSENGER: If this is why thou dreadest to return.</p>
<p class="poem1">OEDIPUS: Yea, lest the god’s word be fulfilled in me.</p>
<p class="poem1">MESSENGER: Lest through thy parents thou shouldst be accursed?</p>
<p class="poem1">OEDIPUS: This and none other is my constant dread.</p>
<p class="poem1">MESSENGER: Dost thou not know thy fears are baseless all?</p>
<p class="poem1">OEDIPUS: How baseless, if I am their very son?</p>
<p class="poem1">MESSENGER: Since Polybus was naught to thee in blood.</p>
<p class="poem1">OEDIPUS: What say’st thou? was not Polybus my sire?</p>
<p class="poem1">MESSENGER: As much thy sire as I am, and no more.</p>
<p class="poem1">OEDIPUS: My sire no more to me than one who is naught?</p>
<p class="poem1">MESSENGER: Since I begat thee not, no more did he.</p>
<p class="poem1">OEDIPUS: What reason had he then to call me son?</p>
<p class="poem1">MESSENGER: Know that he took thee from my hands, a gift.</p>
<p class="poem1">OEDIPUS</p>
</a><p class="poem"><a id="page_47"></a><a id="page_48">Yet, if no child of his, he loved me well.</a></p><a id="page_48">
<p class="poem1">MESSENGER</p>
<p class="poem">A childless man till then, he warmed to thee.</p>
<p class="poem1">OEDIPUS: A foundling or a purchased slave, this child?</p>
<p class="poem1">MESSENGER: I found thee in Cithaeron’s wooded glens.</p>
<p class="poem1">OEDIPUS: What led thee to explore those upland glades?</p>
<p class="poem1">MESSENGER: My business was to tend the mountain flocks.</p>
<p class="poem1">OEDIPUS: A vagrant shepherd journeying for hire?</p>
<p class="poem1">MESSENGER: True, but thy savior in that hour, my son.</p>
<p class="poem1">OEDIPUS: My savior? from what harm? what ailed me then?</p>
<p class="poem1">MESSENGER: Those ankle joints are evidence enow.</p>
<p class="poem1">OEDIPUS: Ah, why remind me of that ancient sore?</p>
<p class="poem1">MESSENGER: I loosed the pin that riveted thy feet.</p>
<p class="poem1">OEDIPUS: Yes, from my cradle that dread brand I bore.</p>
<p class="poem1">MESSENGER: Whence thou deriv’st the name that still is thine.</p>
<p class="poem1">OEDIPUS: Who did it? I adjure thee, tell me who</p>
<p class="poem">Say, was it father, mother?</p>
</a><p class="poem1"><a id="page_48"></a><a id="page_49">MESSENGER: I know not.</a></p><a id="page_49">
<p class="poem">The man from whom I had thee may know more.</p>
<p class="poem1">OEDIPUS: What, did another find me, not thyself?</p>
<p class="poem1">MESSENGER: Not I; another shepherd gave thee me.</p>
<p class="poem1">OEDIPUS: Who was he? Would’st thou know again the man?</p>
<p class="poem1">MESSENGER: He passed indeed for one of Laius’ house.</p>
<p class="poem1">OEDIPUS: The king who ruled the country long ago?</p>
<p class="poem1">MESSENGER: The same: he was a herdsman of the king.</p>
<p class="poem1">OEDIPUS: And is he living still for me to see him?</p>
<p class="poem1">MESSENGER: His fellow-countrymen should best know that.</p>
<p class="poem1">OEDIPUS: Doth any bystander among you know</p>
<p class="poem">The herd he speaks of, or by seeing him</p>
<p class="poem">Afield or in the city? answer straight!</p>
<p class="poem">The hour hath come to clear this business up.</p>
<p class="poem1">CHORUS: Methinks he means none other than the hind</p>
<p class="poem">Whom thou anon wert fain to see; but that</p>
<p class="poem">Our queen Jocasta best of all could tell.</p>
<p class="poem1">OEDIPUS: Madam, dost know the man we sent to fetch?</p>
<p class="poem">Is the same of whom the stranger speaks?</p>
<p class="poem1">JOCASTA: Who is the man? What matter? Let it be.</p>
</a><p class="poem"><a id="page_49"></a><a id="page_50">‘Twere waste of thought to weigh such idle words.</a></p><a id="page_50">
<p class="poem1">OEDIPUS: No, with such guiding clues I cannot fail</p>
<p class="poem">To bring to light the secret of my birth.</p>
<p class="poem1">JOCASTA: Oh, as thou carest for thy life, give o’er</p>
<p class="poem">This quest. Enough the anguish I endure.</p>
<p class="poem1">OEDIPUS: Be of good cheer; though I be proved the son</p>
<p class="poem">Of a bondwoman, aye, through three descents</p>
<p class="poem">Triply a slave, thy honor is unsmirched.</p>
<p class="poem1">JOCASTA: Yet humor me, I pray thee; do not this.</p>
<p class="poem1">OEDIPUS: I cannot; I must probe this matter home.</p>
<p class="poem1">JOCASTA: ‘Tis for thy sake I advise thee for the best.</p>
<p class="poem1">OEDIPUS: I grow impatient of this best advice.</p>
<p class="poem1">JOCASTA: Ah mayst thou ne’er discover who thou art!</p>
<p class="poem1">OEDIPUS: Go, fetch me here the herd, and leave yon woman</p>
<p class="poem">To glory in her pride of ancestry.</p>
<p class="poem1">JOCASTA: O woe is thee, poor wretch! With that last word</p>
<p class="poem">I leave thee, henceforth silent evermore.</p>
<p class="poem">[Exit JOCASTA]</p>
<p class="poem1">CHORUS: Why, Oedipus, why stung with passionate grief</p>
<p class="poem">Hath the queen thus departed? Much I fear</p>
<p class="poem">From this dead calm will burst a storm of woes.</p>
</a><p class="poem1"><a id="page_50"></a><a id="page_51">OEDIPUS: Let the storm burst, my fixed resolve still holds,</a></p><a id="page_51">
<p class="poem">To learn my lineage, be it ne’er so low.</p>
<p class="poem">It may be she with all a woman’s pride</p>
<p class="poem">Thinks scorn of my base parentage. But I</p>
<p class="poem">Who rank myself as Fortune’s favorite child,</p>
<p class="poem">The giver of good gifts, shall not be shamed.</p>
<p class="poem">She is my mother and the changing moons</p>
<p class="poem">My brethren, and with them I wax and wane.</p>
<p class="poem">Thus sprung why should I fear to trace my birth?</p>
<p class="poem">Nothing can make me other than I am.</p>
<p class="poem1">CHORUS:</p>
<p class="poem"><em class="italic">(Str.)</em></p>
<p class="poem">If my soul prophetic err not, if my wisdom aught avail,</p>
<p class="poemi">Thee, Cithaeron, I shall hail,</p>
<p class="poem">As the nurse and foster-mother of our Oedipus shall greet</p>
<p class="poem">Ere tomorrow’s full moon rises, and exalt thee as is meet.</p>
<p class="poem">Dance and song shall hymn thy praises, lover of our royal race.</p>
<p class="poemi">Phoebus, may my words find grace!</p>
<p class="poem1"><em class="italic">(Ant.)</em></p>
<p class="poem">Child, who bare thee, nymph or goddess? sure thy sure was more than</p>
<p class="poem">man,</p>
<p class="poemi">Haply the hill-roamer Pan.</p>
<p class="poem">Of did Loxias beget thee, for he haunts the upland wold;</p>
<p class="poem">Or Cyllene’s lord, or Bacchus, dweller on the hilltops cold?</p>
<p class="poem">Did some Heliconian Oread give him thee, a new-born joy?</p>
<p class="poemi">Nymphs with whom he love to toy?</p>
<p class="poem1">OEDIPUS: Elders, if I, who never yet before</p>
<p class="poem">Have met the man, may make a guess, methinks</p>
</a><p class="poem"><a id="page_51"></a><a id="page_52">I see the herdsman who we long have sought;</a></p><a id="page_52">
<p class="poem">His time-worn aspect matches with the years</p>
<p class="poem">Of yonder aged messenger; besides</p>
<p class="poem">I seem to recognize the men who bring him</p>
<p class="poem">As servants of my own. But you, perchance,</p>
<p class="poem">Having in past days known or seen the herd,</p>
<p class="poem">May better by sure knowledge my surmise.</p>
<p class="poem1">CHORUS: I recognize him; one of Laius’ house;</p>
<p class="poem">A simple hind, but true as any man.</p>
<p class="poem">[Enter HERDSMAN.]</p>
<p class="poem1">OEDIPUS: Corinthian, stranger, I address thee first,</p>
<p class="poem">Is this the man thou meanest!</p>
<p class="poem1">MESSENGER: This is he.</p>
<p class="poem1">OEDIPUS: And now old man, look up and answer all</p>
<p class="poem">I ask thee. Wast thou once of Laius’ house?</p>
<p class="poem1">HERDSMAN: I was, a thrall, not purchased but home-bred.</p>
<p class="poem1">OEDIPUS: What was thy business? how wast thou employed?</p>
<p class="poem1">HERDSMAN: The best part of my life I tended sheep.</p>
<p class="poem1">OEDIPUS: What were the pastures thou didst most frequent?</p>
<p class="poem1">HERDSMAN: Cithaeron and the neighboring alps.</p>
<p class="poem1">OEDIPUS: Then there</p>
<p class="poem">Thou must have known yon man, at least by fame?</p>
</a><p class="poem1"><a id="page_52"></a><a id="page_53">HERDSMAN: Yon man? in what way? what man dost thou mean?</a></p><a id="page_53">
<p class="poem1">OEDIPUS: The man here, having met him in past times …</p>
<p class="poem1">HERDSMAN: Off-hand I cannot call him well to mind.</p>
<p class="poem1">MESSENGER: No wonder, master. But I will revive</p>
<p class="poem">His blunted memories. Sure he can recall</p>
<p class="poem">What time together both we drove our flocks,</p>
<p class="poem">He two, I one, on the Cithaeron range,</p>
<p class="poem">For three long summers; I his mate from spring</p>
<p class="poem">Till rose Arcturus; then in winter time</p>
<p class="poem">I led mine home, he his to Laius’ folds.</p>
<p class="poem">Did these things happen as I say, or no?</p>
<p class="poem1">HERDSMAN: ‘Tis long ago, but all thou say’st is true.</p>
<p class="poem1">MESSENGER: Well, thou mast then remember giving me</p>
<p class="poem">A child to rear as my own foster-son?</p>
<p class="poem1">HERDSMAN: Why dost thou ask this question? What of that?</p>
<p class="poem1">MESSENGER: Friend, he that stands before thee was that child.</p>
<p class="poem1">HERDSMAN: A plague upon thee! Hold thy wanton tongue!</p>
<p class="poem1">OEDIPUS: Softly, old man, rebuke him not; thy words</p>
<p class="poem">Are more deserving chastisement than his.</p>
<p class="poem1">HERDSMAN: O best of masters, what is my offense?</p>
</a><p class="poem1"><a id="page_53"></a><a id="page_54">OEDIPUS: Not answering what he asks about the child.</a></p><a id="page_54">
<p class="poem1">HERDSMAN: He speaks at random, babbles like a fool.</p>
<p class="poem1">OEDIPUS: If thou lack’st grace to speak, I’ll loose thy tongue.</p>
<p class="poem1">HERDSMAN: For mercy’s sake abuse not an old man.</p>
<p class="poem1">OEDIPUS: Arrest the villain, seize and pinion him!</p>
<p class="poem1">HERDSMAN: Alack, alack!</p>
<p class="poem">What have I done? what wouldst thou further learn?</p>
<p class="poem1">OEDIPUS: Didst give this man the child of whom he asks?</p>
<p class="poem1">HERDSMAN: I did; and would that I had died that day!</p>
<p class="poem1">OEDIPUS: And die thou shalt unless thou tell the truth.</p>
<p class="poem1">HERDSMAN: But, if I tell it, I am doubly lost.</p>
<p class="poem1">OEDIPUS: The knave methinks will still prevaricate.</p>
<p class="poem1">HERDSMAN: Nay, I confessed I gave it long ago.</p>
<p class="poem1">OEDIPUS: Whence came it? was it thine, or given to thee?</p>
<p class="poem1">HERDSMAN: I had it from another, ‘twas not mine.</p>
<p class="poem1">OEDIPUS: From whom of these our townsmen, and what house?</p>
<p class="poem1">HERDSMAN: Forbear for God’s sake, master, ask no more.</p>
</a><p class="poem1"><a id="page_54"></a><a id="page_55">OEDIPUS: If I must question thee again, thou’rt lost.</a></p><a id="page_55">
<p class="poem1">HERDSMAN: Well then—it was a child of Laius’ house.</p>
<p class="poem1">OEDIPUS: Slave-born or one of Laius’ own race?</p>
<p class="poem1">HERDSMAN: Ah me!</p>
<p class="poem">I stand upon the perilous edge of speech.</p>
<p class="poem1">OEDIPUS: And I of hearing, but I still must hear.</p>
<p class="poem1">HERDSMAN: Know then the child was by repute his own,</p>
<p class="poem">But she within, thy consort best could tell.</p>
<p class="poem1">OEDIPUS: What! she, she gave it thee?</p>
<p class="poem1">HERDSMAN: ‘Tis so, my king.</p>
<p class="poem1">OEDIPUS: With what intent?</p>
<p class="poem1">HERDSMAN: To make away with it.</p>
<p class="poem1">OEDIPUS: What, she its mother.</p>
<p class="poem1">HERDSMAN: Fearing a dread weird.</p>
<p class="poem1">OEDIPUS: What weird?</p>
<p class="poem1">HERDSMAN: ‘Twas told that he should slay his sire.</p>
<p class="poem1">OEDIPUS: What didst thou give it then to this old man?</p>
</a><p class="poem1"><a id="page_55"></a><a id="page_56">HERDSMAN: Through pity, master, for the babe. I thought</a></p><a id="page_56">
<p class="poem">He’d take it to the country whence he came;</p>
<p class="poem">But he preserved it for the worst of woes.</p>
<p class="poem">For if thou art in sooth what this man saith,</p>
<p class="poem">God pity thee! thou wast to misery born.</p>
<p class="poem1">OEDIPUS: Ah me! ah me! all brought to pass, all true!</p>
<p class="poem">O light, may I behold thee nevermore!</p>
<p class="poem">I stand a wretch, in birth, in wedlock cursed,</p>
<p class="poem">A parricide, incestuously, triply cursed!</p>
<p class="poem">[Exit OEDIPUS]</p>
<p class="poem1">CHORUS:</p>
<p class="poem"><em class="italic">(Str. 1)</em></p>
<p class="poemi">Races of mortal man</p>
<p class="poemi">Whose life is but a span,</p>
<p class="poem">I count ye but the shadow of a shade!</p>
<p class="poemi">For he who most doth know</p>
<p class="poemi">Of bliss, hath but the show;</p>
<p class="poem">A moment, and the visions pale and fade.</p>
<p class="poem">Thy fall, O Oedipus, thy piteous fall</p>
<p class="poem">Warns me none born of women blest to call.</p>
<p class="poem1"><em class="italic">(Ant. 1)</em></p>
<p class="poemi">For he of marksmen best,</p>
<p class="poemi">O Zeus, outshot the rest,</p>
<p class="poem">And won the prize supreme of wealth and power.</p>
<p class="poemi">By him the vulture maid</p>
<p class="poemi">Was quelled, her witchery laid;</p>
<p class="poem">He rose our savior and the land’s strong tower.</p>
<p class="poem">We hailed thee king and from that day adored</p>
<p class="poem">Of mighty Thebes the universal lord.</p>
</a><p class="poem1"><a id="page_56"></a><a id="page_57"><em class="italic">(Str. 2)</em></a></p><a id="page_57">
<p class="poemi">O heavy hand of fate!</p>
<p class="poemi">Who now more desolate,</p>
<p class="poem">Whose tale more sad than thine, whose lot more dire?</p>
<p class="poemi">O Oedipus, discrowned head,</p>
<p class="poemi">Thy cradle was thy marriage bed;</p>
<p class="poem">One harborage sufficed for son and sire.</p>
<p class="poem">How could the soil thy father eared so long</p>
<p class="poem">Endure to bear in silence such a wrong?</p>
<p class="poem1"><em class="italic">(Ant. 2)</em></p>
<p class="poemi">All-seeing Time hath caught</p>
<p class="poemi">Guilt, and to justice brought</p>
<p class="poem">The son and sire commingled in one bed.</p>
<p class="poemi">O child of Laius’ ill-starred race</p>
<p class="poemi">Would I had ne’er beheld thy face;</p>
<p class="poem">I raise for thee a dirge as o’er the dead.</p>
<p class="poem">Yet, sooth to say, through thee I drew new breath,</p>
<p class="poem">And now through thee I feel a second death.</p>
<p class="poem">[Enter SECOND MESSENGER.]</p>
<p class="poem1">SECOND MESSENGER: Most grave and reverend senators of Thebes,</p>
<p class="poem">What Deeds ye soon must hear, what sights behold</p>
<p class="poem">How will ye mourn, if, true-born patriots,</p>
<p class="poem">Ye reverence still the race of Labdacus!</p>
<p class="poem">Not Ister nor all Phasis’ flood, I ween,</p>
<p class="poem">Could wash away the blood-stains from this house,</p>
<p class="poem">The ills it shrouds or soon will bring to light,</p>
<p class="poem">Ills wrought of malice, not unwittingly.</p>
<p class="poem">The worst to bear are self-inflicted wounds.</p>
</a><p class="poem1"><a id="page_57"></a><a id="page_58">CHORUS: Grievous enough for all our tears and groans</a></p><a id="page_58">
<p class="poem">Our past calamities; what canst thou add?</p>
<p class="poem1">SECOND MESSENGER: My tale is quickly told and quickly heard.</p>
<p class="poem">Our sovereign lady queen Jocasta’s dead.</p>
<p class="poem1">CHORUS: Alas, poor queen! how came she by her death?</p>
<p class="poem1">SECOND MESSENGER: By her own hand. And all the horror of it,</p>
<p class="poem">Not having seen, yet cannot comprehend.</p>
<p class="poem">Nathless, as far as my poor memory serves,</p>
<p class="poem">I will relate the unhappy lady’s woe.</p>
<p class="poem">When in her frenzy she had passed inside</p>
<p class="poem">The vestibule, she hurried straight to win</p>
<p class="poem">The bridal-chamber, clutching at her hair</p>
<p class="poem">With both her hands, and, once within the room,</p>
<p class="poem">She shut the doors behind her with a crash.</p>
<p class="poem">“Laius,” she cried, and called her husband dead</p>
<p class="poem">Long, long ago; her thought was of that child</p>
<p class="poem">By him begot, the son by whom the sire</p>
<p class="poem">Was murdered and the mother left to breed</p>
<p class="poem">With her own seed, a monstrous progeny.</p>
<p class="poem">Then she bewailed the marriage bed whereon</p>
<p class="poem">Poor wretch, she had conceived a double brood,</p>
<p class="poem">Husband by husband, children by her child.</p>
<p class="poem">What happened after that I cannot tell,</p>
<p class="poem">Nor how the end befell, for with a shriek</p>
<p class="poem">Burst on us Oedipus; all eyes were fixed</p>
<p class="poem">On Oedipus, as up and down he strode,</p>
<p class="poem">Nor could we mark her agony to the end.</p>
</a><p class="poem"><a id="page_58"></a><a id="page_59">For stalking to and fro “A sword!” he cried,</a></p><a id="page_59">
<p class="poem">“Where is the wife, no wife, the teeming womb</p>
<p class="poem">That bore a double harvest, me and mine?”</p>
<p class="poem">And in his frenzy some supernal power</p>
<p class="poem">(No mortal, surely, none of us who watched him)</p>
<p class="poem">Guided his footsteps; with a terrible shriek,</p>
<p class="poem">As though one beckoned him, he crashed against</p>
<p class="poem">The folding doors, and from their staples forced</p>
<p class="poem">The wrenched bolts and hurled himself within.</p>
<p class="poem">Then we beheld the woman hanging there,</p>
<p class="poem">A running noose entwined about her neck.</p>
<p class="poem">But when he saw her, with a maddened roar</p>
<p class="poem">He loosed the cord; and when her wretched corpse</p>
<p class="poem">Lay stretched on earth, what followed—O ‘twas dread!</p>
<p class="poem">He tore the golden brooches that upheld</p>
<p class="poem">Her queenly robes, upraised them high and smote</p>
<p class="poem">Full on his eye-balls, uttering words like these:</p>
<p class="poem">“No more shall ye behold such sights of woe,</p>
<p class="poem">Deeds I have suffered and myself have wrought;</p>
<p class="poem">Henceforward quenched in darkness shall ye see</p>
<p class="poem">Those ye should ne’er have seen; now blind to those</p>
<p class="poem">Whom, when I saw, I vainly yearned to know.”</p>
<p class="poemi">Such was the burden of his moan, whereto,</p>
<p class="poem">Not once but oft, he struck with his hand uplift</p>
<p class="poem">His eyes, and at each stroke the ensanguined orbs</p>
<p class="poem">Bedewed his beard, not oozing drop by drop,</p>
<p class="poem">But one black gory downpour, thick as hail.</p>
<p class="poem">Such evils, issuing from the double source,</p>
<p class="poem">Have whelmed them both, confounding man and wife.</p>
<p class="poem">Till now the storied fortune of this house</p>
<p class="poem">Was fortunate indeed; but from this day</p>
<p class="poem">Woe, lamentation, ruin, death, disgrace,</p>
</a><p class="poem"><a id="page_59"></a><a id="page_60">All ills that can be named, all, all are theirs.</a></p><a id="page_60">
<p class="poem1">CHORUS: But hath he still no respite from his pain?</p>
<p class="poem1">SECOND MESSENGER: He cries, “Unbar the doors and let all Thebes</p>
<p class="poem">Behold the slayer of his sire, his mother’s—”</p>
<p class="poem">That shameful word my lips may not repeat.</p>
<p class="poem">He vows to fly self-banished from the land,</p>
<p class="poem">Nor stay to bring upon his house the curse</p>
<p class="poem">Himself had uttered; but he has no strength</p>
<p class="poem">Nor one to guide him, and his torture’s more</p>
<p class="poem">Than man can suffer, as yourselves will see.</p>
<p class="poem">For lo, the palace portals are unbarred,</p>
<p class="poem">And soon ye shall behold a sight so sad</p>
<p class="poem">That he who must abhorred would pity it.</p>
<p class="poem">[Enter OEDIPUS blinded.]</p>
<p class="poem1">CHORUS: Woeful sight! more woeful none</p>
<p class="poem">These sad eyes have looked upon.</p>
<p class="poem">Whence this madness? None can tell</p>
<p class="poem">Who did cast on thee his spell,</p>
<p class="poem">prowling all thy life around,</p>
<p class="poem">Leaping with a demon bound.</p>
<p class="poem">Hapless wretch! how can I brook</p>
<p class="poem">On thy misery to look?</p>
<p class="poem">Though to gaze on thee I yearn,</p>
<p class="poem">Much to question, much to learn,</p>
<p class="poem">Horror-struck away I turn.</p>
<p class="poem1">OEDIPUS: Ah me! ah woe is me!</p>
<p class="poem">Ah whither am I borne!</p>
</a><p class="poem"><a id="page_60"></a><a id="page_61">How like a ghost forlorn</a></p><a id="page_61">
<p class="poem">My voice flits from me on the air!</p>
<p class="poem">On, on the demon goads. The end, ah where?</p>
<p class="poem1">CHORUS: An end too dread to tell, too dark to see.</p>
<p class="poem1">OEDIPUS:</p>
<p class="poem"><em class="italic">(Str. 1)</em></p>
<p class="poem">Dark, dark! The horror of darkness, like a shroud,</p>
<p class="poem">Wraps me and bears me on through mist and cloud.</p>
<p class="poem">Ah me, ah me! What spasms athwart me shoot,</p>
<p class="poem">What pangs of agonizing memory?</p>
<p class="poem1">CHORUS: No marvel if in such a plight thou feel’st</p>
<p class="poem">The double weight of past and present woes.</p>
<p class="poem1">OEDIPUS:</p>
<p class="poem"><em class="italic">(Ant. 1)</em></p>
<p class="poem">Ah friend, still loyal, constant still and kind,</p>
<p class="poemi">Thou carest for the blind.</p>
<p class="poem">I know thee near, and though bereft of eyes,</p>
<p class="poemi">Thy voice I recognize.</p>
<p class="poem1">CHORUS: O doer of dread deeds, how couldst thou mar</p>
<p class="poem">Thy vision thus? What demon goaded thee?</p>
<p class="poem1">OEDIPUS:</p>
<p class="poem"><em class="italic">(Str. 2)</em></p>
<p class="poem">Apollo, friend, Apollo, he it was</p>
<p class="poemi">That brought these ills to pass;</p>
<p class="poem">But the right hand that dealt the blow</p>
<p class="poemi">Was mine, none other. How,</p>
</a><p class="poem"><a id="page_61"></a><a id="page_62">How, could I longer see when sight</a></p><a id="page_62">
<p class="poemi">Brought no delight?</p>
<p class="poem1">CHORUS: Alas! ‘tis as thou sayest.</p>
<p class="poem1">OEDIPUS: Say, friends, can any look or voice</p>
<p class="poem">Or touch of love henceforth my heart rejoice?</p>
<p class="poemi">Haste, friends, no fond delay,</p>
<p class="poemi">Take the twice cursed away</p>
<p class="poemi">Far from all ken,</p>
<p class="poem">The man abhorred of gods, accursed of men.</p>
<p class="poem1">CHORUS: O thy despair well suits thy desperate case.</p>
<p class="poem">Would I had never looked upon thy face!</p>
<p class="poem1">OEDIPUS:</p>
<p class="poem"><em class="italic">(Ant. 2)</em></p>
<p class="poem">My curse on him whoe’er unrived</p>
<p class="poem">The waif’s fell fetters and my life revived!</p>
<p class="poem">He meant me well, yet had he left me there,</p>
<p class="poem">He had saved my friends and me a world of care.</p>
<p class="poem1">CHORUS: I too had wished it so.</p>
<p class="poem1">OEDIPUS: Then had I never come to shed</p>
<p class="poem">My father’s blood nor climbed my mother’s bed;</p>
<p class="poem">The monstrous offspring of a womb defiled,</p>
<p class="poem">Co-mate of him who gendered me, and child.</p>
<p class="poem">Was ever man before afflicted thus,</p>
<p class="poem">Like Oedipus.</p>
<p class="poem1">CHORUS: I cannot say that thou hast counseled well,</p>
</a><p class="poem"><a id="page_62"></a><a id="page_63">For thou wert better dead than living blind.</a></p><a id="page_63">
<p class="poem1">OEDIPUS: What’s done was well done. Thou canst never shake</p>
<p class="poem">My firm belief. A truce to argument.</p>
<p class="poem">For, had I sight, I know not with what eyes</p>
<p class="poem">I could have met my father in the shades,</p>
<p class="poem">Or my poor mother, since against the twain</p>
<p class="poem">I sinned, a sin no gallows could atone.</p>
<p class="poem">Aye, but, ye say, the sight of children joys</p>
<p class="poem">A parent’s eyes. What, born as mine were born?</p>
<p class="poem">No, such a sight could never bring me joy;</p>
<p class="poem">Nor this fair city with its battlements,</p>
<p class="poem">Its temples and the statues of its gods,</p>
<p class="poem">Sights from which I, now wretchedst of all,</p>
<p class="poem">Once ranked the foremost Theban in all Thebes,</p>
<p class="poem">By my own sentence am cut off, condemned</p>
<p class="poem">By my own proclamation ‘gainst the wretch,</p>
<p class="poem">The miscreant by heaven itself declared</p>
<p class="poem">Unclean—and of the race of Laius.</p>
<p class="poem">Thus branded as a felon by myself,</p>
<p class="poem">How had I dared to look you in the face?</p>
<p class="poem">Nay, had I known a way to choke the springs</p>
<p class="poem">Of hearing, I had never shrunk to make</p>
<p class="poem">A dungeon of this miserable frame,</p>
<p class="poem">Cut off from sight and hearing; for ‘tis bliss</p>
<p class="poem">to bide in regions sorrow cannot reach.</p>
<p class="poem">Why didst thou harbor me, Cithaeron, why</p>
<p class="poem">Didst thou not take and slay me? Then I never</p>
<p class="poem">Had shown to men the secret of my birth.</p>
<p class="poem">O Polybus, O Corinth, O my home,</p>
<p class="poem">Home of my ancestors (so wast thou called)</p>
<p class="poem">How fair a nursling then I seemed, how foul</p>
</a><p class="poem"><a id="page_63"></a><a id="page_64">The canker that lay festering in the bud!</a></p><a id="page_64">
<p class="poem">Now is the blight revealed of root and fruit.</p>
<p class="poem">Ye triple high-roads, and thou hidden glen,</p>
<p class="poem">Coppice, and pass where meet the three-branched ways,</p>
<p class="poem">Ye drank my blood, the life-blood these hands spilt,</p>
<p class="poem">My father’s; do ye call to mind perchance</p>
<p class="poem">Those deeds of mine ye witnessed and the work</p>
<p class="poem">I wrought thereafter when I came to Thebes?</p>
<p class="poem">O fatal wedlock, thou didst give me birth,</p>
<p class="poem">And, having borne me, sowed again my seed,</p>
<p class="poem">Mingling the blood of fathers, brothers, children,</p>
<p class="poem">Brides, wives and mothers, an incestuous brood,</p>
<p class="poem">All horrors that are wrought beneath the sun,</p>
<p class="poem">Horrors so foul to name them were unmeet.</p>
<p class="poem">O, I adjure you, hide me anywhere</p>
<p class="poem">Far from this land, or slay me straight, or cast me</p>
<p class="poem">Down to the depths of ocean out of sight.</p>
<p class="poem">Come hither, deign to touch an abject wretch;</p>
<p class="poem">Draw near and fear not; I myself must bear</p>
<p class="poem">The load of guilt that none but I can share.</p>
<p class="poem">[Enter CREON.]</p>
<p class="poem1">CREON: Lo, here is Creon, the one man to grant</p>
<p class="poem">Thy prayer by action or advice, for he</p>
<p class="poem">Is left the State’s sole guardian in thy stead.</p>
<p class="poem1">OEDIPUS: Ah me! what words to accost him can I find?</p>
<p class="poem">What cause has he to trust me? In the past</p>
<p class="poem">I have bee proved his rancorous enemy.</p>
<p class="poem1">CREON: Not in derision, Oedipus, I come</p>
<p class="poem">Nor to upbraid thee with thy past misdeeds.</p>
</a><p class="poem1"><a id="page_64"></a><a id="page_65">(To BYSTANDERS)</a></p><a id="page_65">
<p class="poem">But shame upon you! if ye feel no sense</p>
<p class="poem">Of human decencies, at least revere</p>
<p class="poem">The Sun whose light beholds and nurtures all.</p>
<p class="poem">Leave not thus nakedly for all to gaze at</p>
<p class="poem">A horror neither earth nor rain from heaven</p>
<p class="poem">Nor light will suffer. Lead him straight within,</p>
<p class="poem">For it is seemly that a kinsman’s woes</p>
<p class="poem">Be heard by kin and seen by kin alone.</p>
<p class="poem1">OEDIPUS: O listen, since thy presence comes to me</p>
<p class="poem">A shock of glad surprise—so noble thou,</p>
<p class="poem">And I so vile—O grant me one small boon.</p>
<p class="poem">I ask it not on my behalf, but thine.</p>
<p class="poem1">CREON: And what the favor thou wouldst crave of me?</p>
<p class="poem1">OEDIPUS: Forth from thy borders thrust me with all speed;</p>
<p class="poem">Set me within some vasty desert where</p>
<p class="poem">No mortal voice shall greet me any more.</p>
<p class="poem1">CREON: This had I done already, but I deemed</p>
<p class="poem">It first behooved me to consult the god.</p>
<p class="poem1">OEDIPUS: His will was set forth fully—to destroy</p>
<p class="poem">The parricide, the scoundrel; and I am he.</p>
<p class="poem1">CREON: Yea, so he spake, but in our present plight</p>
<p class="poem">‘Twere better to consult the god anew.</p>
<p class="poem1">OEDIPUS: Dare ye inquire concerning such a wretch?</p>
</a><p class="poem1"><a id="page_65"></a><a id="page_66">CREON: Yea, for thyself wouldst credit now his word.</a></p><a id="page_66">
<p class="poem1">OEDIPUS: Aye, and on thee in all humility</p>
<p class="poem">I lay this charge: let her who lies within</p>
<p class="poem">Receive such burial as thou shalt ordain;</p>
<p class="poem">Such rites ‘tis thine, as brother, to perform.</p>
<p class="poem">But for myself, O never let my Thebes,</p>
<p class="poem">The city of my sires, be doomed to bear</p>
<p class="poem">The burden of my presence while I live.</p>
<p class="poem">No, let me be a dweller on the hills,</p>
<p class="poem">On yonder mount Cithaeron, famed as mine,</p>
<p class="poem">My tomb predestined for me by my sire</p>
<p class="poem">And mother, while they lived, that I may die</p>
<p class="poem">Slain as they sought to slay me, when alive.</p>
<p class="poem">This much I know full surely, nor disease</p>
<p class="poem">Shall end my days, nor any common chance;</p>
<p class="poem">For I had ne’er been snatched from death, unless</p>
<p class="poem">I was predestined to some awful doom.</p>
<p class="poemi">So be it. I reck not how Fate deals with me</p>
<p class="poem">But my unhappy children—for my sons</p>
<p class="poem">Be not concerned, O Creon, they are men,</p>
<p class="poem">And for themselves, where’er they be, can fend.</p>
<p class="poem">But for my daughters twain, poor innocent maids,</p>
<p class="poem">Who ever sat beside me at the board</p>
<p class="poem">Sharing my viands, drinking of my cup,</p>
<p class="poem">For them, I pray thee, care, and, if thou willst,</p>
<p class="poem">O might I feel their touch and make my moan.</p>
<p class="poem">Hear me, O prince, my noble-hearted prince!</p>
<p class="poem">Could I but blindly touch them with my hands</p>
<p class="poem">I’d think they still were mine, as when I saw.</p>
<p class="poem">[ANTIGONE and ISMENE are led in.]</p>
<p class="poem">What say I? can it be my pretty ones</p>
</a><p class="poem"><a id="page_66"></a><a id="page_67">Whose sobs I hear? Has Creon pitied me</a></p><a id="page_67">
<p class="poem">And sent me my two darlings? Can this be?</p>
<p class="poem1">CREON: ‘Tis true; ‘twas I procured thee this delight,</p>
<p class="poem">Knowing the joy they were to thee of old.</p>
<p class="poem1">OEDIPUS: God speed thee! and as meed for bringing them</p>
<p class="poem">May Providence deal with thee kindlier</p>
<p class="poem">Than it has dealt with me! O children mine,</p>
<p class="poem">Where are ye? Let me clasp you with these hands,</p>
<p class="poem">A brother’s hands, a father’s; hands that made</p>
<p class="poem">Lack-luster sockets of his once bright eyes;</p>
<p class="poem">Hands of a man who blindly, recklessly,</p>
<p class="poem">Became your sire by her from whom he sprang.</p>
<p class="poem">Though I cannot behold you, I must weep</p>
<p class="poem">In thinking of the evil days to come,</p>
<p class="poem">The slights and wrongs that men will put upon you.</p>
<p class="poem">Where’er ye go to feast or festival,</p>
<p class="poem">No merrymaking will it prove for you,</p>
<p class="poem">But oft abashed in tears ye will return.</p>
<p class="poem">And when ye come to marriageable years,</p>
<p class="poem">Where’s the bold wooers who will jeopardize</p>
<p class="poem">To take unto himself such disrepute</p>
<p class="poem">As to my children’s children still must cling,</p>
<p class="poem">For what of infamy is lacking here?</p>
<p class="poem">“Their father slew his father, sowed the seed</p>
<p class="poem">Where he himself was gendered, and begat</p>
<p class="poem">These maidens at the source wherefrom he sprang.”</p>
<p class="poem">Such are the gibes that men will cast at you.</p>
<p class="poem">Who then will wed you? None, I ween, but ye</p>
<p class="poem">Must pine, poor maids, in single barrenness.</p>
<p class="poem">O Prince, Menoeceus’ son, to thee, I turn,</p>
</a><p class="poem"><a id="page_67"></a><a id="page_68">With the it rests to father them, for we</a></p><a id="page_68">
<p class="poem">Their natural parents, both of us, are lost.</p>
<p class="poem">O leave them not to wander poor, unwed,</p>
<p class="poem">Thy kin, nor let them share my low estate.</p>
<p class="poem">O pity them so young, and but for thee</p>
<p class="poem">All destitute. Thy hand upon it, Prince.</p>
<p class="poem">To you, my children I had much to say,</p>
<p class="poem">Were ye but ripe to hear. Let this suffice:</p>
<p class="poem">Pray ye may find some home and live content,</p>
<p class="poem">And may your lot prove happier than your sire’s.</p>
<p class="poem1">CREON: Thou hast had enough of weeping; pass within.</p>
<p class="poem1">OEDIPUS: I must obey,</p>
<p class="poem">Though ‘tis grievous.</p>
<p class="poem1">CREON: Weep not, everything must have its day.</p>
<p class="poem1">OEDIPUS: Well I go, but on conditions.</p>
<p class="poem1">CREON: What thy terms for going, say.</p>
<p class="poem1">OEDIPUS: Send me from the land an exile.</p>
<p class="poem1">CREON: Ask this of the gods, not me.</p>
<p class="poem1">OEDIPUS: But I am the gods’ abhorrence.</p>
<p class="poem1">CREON: Then they soon will grant thy plea.</p>
<p class="poem1">OEDIPUS: Lead me hence, then, I am willing.</p>
</a><p class="poem1"><a id="page_68"></a><a id="page_69">CREON: Come, but let thy children go.</a></p><a id="page_69">
<p class="poem1">OEDIPUS: Rob me not of these my children!</p>
<p class="poem1">CREON: Crave not mastery in all,</p>
<p class="poem">For the mastery that raised thee was thy bane and wrought thy fall.</p>
<p class="poem1">CHORUS: Look ye, countrymen and Thebans, this is Oedipus the great,</p>
<p class="poem">He who knew the Sphinx’s riddle and was mightiest in our state.</p>
<p class="poem">Who of all our townsmen gazed not on his fame with envious eyes?</p>
<p class="poem">Now, in what a sea of troubles sunk and overwhelmed he lies!</p>
<p class="poem">Therefore wait to see life’s ending ere thou count one mortal blest;</p>
<p class="poem">Wait till free from pain and sorrow he has gained his final rest.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Chapter02.vue?39ba89f9